export const texts = {
    ABANDONNER: 'Abandonner',
    ACTIVER: 'Activer',
    ACTIVATED: 'Activé',
    DEACTIVATED: 'Désactivé',
    SENT: 'Envoyé',
    SENT_MULTIPLE: 'Envoyées',
    ADRESSE: 'Adresse',
    ADRESSE_DU_DOMICILE: 'Adresse du domicile',
    ADRESSE_DU_DOMICILE_FISCAL: 'Adresse du domicile fiscal',
    ADRESSE_DU_SIEGE_SOCIAL: 'Adresse du siège social',
    ADRESSE_DOMICILE_SIGNATAIRE: 'Adresse du domicile du signataire',
    ADRESSE_EMAIL: 'Adresse e-mail',
    PHONE_NUMBER: 'Numéro de téléphone',
    ADRESSE_EMAIL_SAISIE_PAS_VALIDE: "L'adresse e-mail saisie n'est pas valide.",
    CONNEXION: 'Connexion',
    QUITTER: 'Quitter',
    ASSISTANCE: 'ASSISTANCE',
    ASSISTANCE_DIRECTIONS:
        "Si vous rencontrez un problème lors de votre parcours de souscription, vous pouvez contacter l'équipe Peqan au 01 42 89 12 87.",
    MY_SPACE: 'Mon espace',
    CONFIRMER: 'Confirmer',
    CONFIRMER_CREATE_SUBSCRIPTION: 'Créer souscription',
    CONTINUER: 'Continuer',
    CANCEL: 'Annuler',
    GO_BACK: 'Revenir',
    APPLY: 'Appliquer',
    A_NOTTER: 'A noter',
    DEJA_QUITTER: 'Êtes-vous sûr(e) de vouloir déjà nous quitter\xa0?',
    CONTINUE_YOUR_SUBSCRIPTION: 'Continuez votre souscription',
    CONTINUE_SUBSCRIPTION: 'Continuer la souscription',
    CANCEL_ONGOING_SUBSCRIPTION: 'Annuler la souscription en cours',
    CANCEL_SUBSCRIPTION_TITLE: 'Annuler la souscription en cours',
    CONFIRM_CANCEL_SUBSCRIPTION: 'Etes-vous sûr de vouloir annuler la souscription en cours\xa0?',
    CONTINUER_SOUSCRIPTION:
        'Vous pouvez revenir à tout moment pour continuer votre souscription. Pour cela, rien de plus simple, il suffit de vous reconnecter avec vos identifiants. Si vous quittez le formulaire, nous vous enverrons automatiquement un e-mail avec le lien de reconnexion.',
    CONTINUER_INSCRIPTION:
        'Vous pouvez revenir à tout moment pour continuer votre inscription en tant que partenaire des produits Peqan. Pour cela, rien de plus simple, il suffit de vous reconnecter avec vos identifiants.',
    A_TRES_BIENTOT: 'A très bientôt,',
    L_EQUIPE_SGP_NAME: sgpName => `L'équipe ${sgpName}.`,
    BIENVENUE: 'Bienvenue',
    NO_CONVENTIONS_FOR_AVAILABLE_FUNDS: "Vous n'avez plus de convention de distribution en cours.",
    NO_AVAILABLE_FUNDS:
        "Avant de créer une nouvelle souscription, assurez-vous d'avoir signé une convention de distribution dans l'onglet PRODUITS.",
    CETTE_ADRESSE_EXISTE_DEJA: 'Cette adresse existe déjà dans notre base de données.',
    CHANGER_LE_MOT_DU_PASSE: 'Changer le mot de passe',
    CLICK_HERE: 'Cliquez ici',
    CLICK: 'Cliquez',
    HERE: 'ici',
    VOUS_POUVEZ_REVENIR:
        'Vous pouvez revenir, à tout moment, sur les formulaires déjà validés et modifier les réponses fournies.',
    POUR_CELA: "Pour cela, il vous suffit de cliquer sur l'étape souhaitée en haut de la page.",

    APPORTEUR: "Apporteur d'affaires",
    COMMERCIALISATEUR: 'Conseil en Investissement Financier',
    PP_TEXT: 'Individu doté, en tant que tel, de la personnalité juridique.',
    PM_TEXT: 'Entité juridique identifiée par sa dénomination, son siège social et son patrimoine.',

    SELECTIONNEZ_VOTRE_PROFIL: 'Sélectionnez votre profil investisseur',

    COCHER_UNE_DES_DEUX_CASES: 'Cocher une des deux cases suivantes:',
    CODE_POSTAL: 'Code postal',
    CONDITIONS_GENERALES: "Conditions Générales d'Utilisation",

    HAS_PROFESSIONAL_POSITION:
        'Vous avez exercé pendant au moins un an une position professionnelle exigeant une connaissance des investissements en instruments financiers.',
    MISSING_PROFESSIONAL_POSITION:
        "Vous n'avez pas exercé pendant au moins un an une position professionnelle exigeant une connaissance des investissements en instruments financiers.",

    SUM_INFERIOR: amount => `Le montant ne peut être inférieur à ${amount} €`,
    SUM_SUPERIOR: amount => `Le montant ne peut être supérieur à ${amount} €`,
    SUM_RANGE: 'Le montant saisi ne correspond pas à la catégorie choisie',

    EMPTY_NEW_PASSWORD: 'Veuillez entrer un nouveau mot de passe pour continuer.',
    CONFIRM_NEW_PASSWORD: 'Confirmez le nouveau mot de passe',
    CONFIRM_PASSWORD: 'Confirmez votre mot de passe',
    CONFIRM_EMAIL: 'Confirm Email',

    COORDONNEES: 'Coordonnées',
    CO_SUBSCRIBER_CONTACT_INFO: 'Coordonnées co-souscripteur',
    COORDONNEES_CODE_SMS: 'Coordonnées - Code SMS',
    COORDONNEES_CO_SUBSCRIBER_CODE_SMS: 'Coordonnées co-souscripteur - Code SMS',

    CREATE_SERVICER_USER: 'Créer utilisateur servicer',

    CREATE_PROVIDER_USER: 'Créer utilisateur AIFM',
    SIMPLE_SUBSCRIPTION: 'Souscription simple',
    CO_SUBSCRIPTION: 'Co-souscription',
    CO_SUBSCRIPTION_DISCLAIMER:
        "Dans le cadre de la co-souscription, vous renseignerez tout d'abord les informations concernant le premier souscripteur, puis celles du second.",
    DATE_DE_NAISSANCE: 'Date de naissance',
    DATE_DE_NAISSANCE_TABLE_HEADER: 'Date de naissance  (jj/mm/aaaa)',
    DEPARTEMENT_DE_NAISSANCE: 'Département de naissance',
    COUNTRY_OF_BIRTH: 'Pays de naissance',

    FUND_REGULATIONS: 'Règlement du fonds',
    FUND_REGULATIONS_FPS: 'Prospectus et Règlement',
    FUND_REGULATIONS_FPS_2: 'Prospectus et Règlement du fonds',
    FUND_REGULATIONS_SLP: 'Statuts de la SLP',
    CONSULTANT_ARGUMENT: 'Argumentaire clients',
    REGULATORY_PACK: 'Pack Règlementaire',
    EVERGREEN: 'Evergreen',
    CUT_OFF_DAYS: 'Cutoff (jours ouvrables avant la fin du mois)',
    PAYMENT_DAYS: 'Nombres de jours de paiement',
    INVALID_INPUT: "La valeur saisie n'est pas valide",
    ADVISOR_PRESENTATION: 'Présentation conseiller',
    BROCHURE_AMF: 'Brochure AMF',
    AMF_NUMBER: 'Numéro AMF',
    REPLAY_WEBINAR: 'Replay webinar',
    CUSTOMER_PRESENTATION: 'Présentation clients',
    WEBINAR: 'Webinar',
    INSCRIPTION_WEBINAR: 'Inscription Webinar',
    CONSULTANT_PRESENTATION: 'Présentation conseiller',
    PARTNER_LOGO: 'Image produit - page accueil partenaires',
    URL_ERROR: 'Vous devez saisir une URL pour continuer.',
    INVESTEMENT_CHARACTERISTICS: 'Caractéristiques de votre souscription',
    INVESTEMENT_CHARACTERISTICS_SUBTITLE:
        'Compte tenu des différents renseignements fournis, veuillez trouver ci-après les caractéristiques de votre souscription\xa0:',
    INVESTOR_SURVEY_PM: 'Votre actif, passif et investissements',
    INVESTOR_SURVEY_PM_SUBTITLE:
        "L'investissement dans le Fonds comporte des risques et nous devons nous assurer que vous disposez d'une capacité financière suffisante pour faire face aux risques liés à l'investissement dans le fonds",

    HOMEPAGE: 'Accueil',
    DASHBOARD: 'Tableau de bord',
    DECONNEXION: 'Déconnexion',
    DESACTIVER: 'Désactiver',
    CHANGE_ROLE: 'Changer le rôle',
    E_MAIL: 'E-mail',
    EMAIL_INVITATION_SERA_ENVOYE: "Un e-mail d'invitation sera envoyé à l'adresse saisie.",
    ENVOYER: 'ENVOYER',
    ENVOYER_UN_LIEN_PAR_EMAIL_POUR_REINITIALISER:
        "Vous allez recevoir un e-mail de réinitialisation de votre mot de passe d'ici quelques minutes.",
    ENVOYER_UN_MESSAGE: 'Envoyer un message',
    ENVOYER_UN_SMS: 'Envoyer un SMS',
    ETES_VOUS_SURS_DE_VOULOIR_SUPPRIMER: 'Êtes-vous sûrs de vouloir supprimer cet enregistrement?',
    EMAIL_ADRESSE_NEST_ASSOICEE: "Cette adresse e-mail n'est associée à aucun compte.",
    VEUILLEZ_RENSEIGNER: "Veuillez renseigner l'adresse e-mail associée à votre compte.",
    EMAIL_ADDRESS_NOT_VERIFIED: "Cette adresse e-mail n'est pas associée à aucun compte actif.",

    FINALISER_VOTRE_INSCRIPTION: 'Finaliser votre inscription',
    FORGOT_PASSWORD: 'Forgot Password',
    GENERIC_STEP_PAGE: 'Generic step page',
    IDENTIFIANT: 'Identifiant',
    IDENTIFIANTS_INVALIDES: 'Les identifiants sont invalides. Veuillez réessayer.',
    INSCRIPTION_AVEC_SUCCES: 'Inscription avec succès.',
    ACCOUNT_ALREADY_CONFIRMED: 'Votre compte est déjà confirmé.',
    JE_M_INSCRIS: "Je m'inscris",
    TWO_FACTOR_AUTHENTICATION_TITLE: 'Authentification à deux facteurs',
    ENTER_CODE_FROM_SMS: 'Entrez le code de confirmation que vous avez reçu par SMS',

    J_ACCEPTE: "J'accepte les ",
    J_ACCEPTE_D_ETRE_CONTACTEE: isDistributor =>
        `J'accepte d'être contacté par e-mail ou par téléphone pour les besoins ${
            isDistributor ? 'relatifs à la commercialisation du produit' : 'de ma souscription'
        }.`,
    JE_SUIS_NON_US_PERSON: 'Je ne suis pas un ressortissant ou résident fiscal US',
    JE_SUIS_US_PERSON: 'Je suis un ressortissant ou résident fiscal US',

    LE_MOT_DE_PASSE_DOIT_CONTENIR:
        'Le mot de passe doit contenir au moins 8 caractères dont au moins un caractère spécial, une majuscule et un chiffre.',
    PASSWORDS_MUST_MATCH: 'Les mots de passe ne correspondent pas.',

    LIEN_EXPIRE: 'Lien expiré',
    LIEN_POUR_LA_CONFIRMATION_A_EXPIRE: 'Le lien pour la confirmation du compte a expiré.',
    LIEN_POUR_REINITIALISATION_DU_MOT_DU_PASSE_EXPIRE:
        'Le lien pour réinitialisation du mot du passe a expiré.',

    LA_SOUSCRIPTION_N_EST_PAS_POSSIBLE:
        "La souscription en ligne n'est pas possible pour une US Person.",

    LE_CODE_N_EST_PAS_VALIDE: "Le code saisi n'est pas valide.",
    LE_CODE_N_EST_PLUS_VALIDE: "Le code saisi n'est plus valide.",
    CODE_REQUIRED: 'Vous devez saisir le code pour continuer',
    CODE_EXPIRED_RETRY: "Le code saisi n'est pas valide. Réactualisez la page pour recommencer.",
    LE_NUMERO_SERA_UTILISE_POUR_ENVOYER:
        'Le numéro de téléphone sera utilisé pour envoyer un SMS de confirmation.',
    MOBIL_FRANCAIS: "Pour les numéros de mobile français le préfixe n'est pas nécessaire.",

    MERCI_DE_VOUS_RAPPROCHER:
        'Merci de vous rapprocher à un de nos conseillers en utilisant ce numéro de téléphone: +33 1 11 22 33 44.',

    POLITICALLY_EXPOSED_INFO_TITLE: 'Personne Politiquement Exposée',
    POLITICALLY_EXPOSED_INFO_CONTENT_1: 'Une Personne Politiquement Exposée est une personne qui :',
    POLITICALLY_EXPOSED_INFO_CONTENT_2:
        "exerce ou a exercé des fonctions politiques, juridictionnelles ou administratives pour le compte de la France, d'un État étranger ou d'une organisation internationale ; ou",
    POLITICALLY_EXPOSED_INFO_CONTENT_3:
        'dont un membre direct de la famille ou un des proches sans liens familiaux est lui-même une PPE.',
    POLITICALLY_EXPOSED_OPTION_1_HELPER_TITLE:
        "I - Liste des fonctions pour lesquelles la qualification de PPE peut être retenue conformément à l'article R561-18 du CMF :",
    POLITICALLY_EXPOSED_OPTION_1_HELPER_CONTENT: {
        1: "Chef d'État, Chef de gouvernement, membre d'un gouvernement national ou de la Commission Européennes ;",
        2: "Membre d'une assemblée parlementaire nationale ou du Parlement européen, membre de l'organe dirigeant d'un parti ou groupement politique soumis aux dispositions de la loi n° 88-227 du 11 mars 1988 ou d'un parti ou groupement politique étranger ;",
        3: "Membre d'une cour suprême, d'une cour constitutionnelle ou d'une autre haute juridiction dont les décisions ne sont pas, sauf circonstances exceptionnelles, susceptibles de recours ;",
        4: "Membre d'une cour des comptes ;",
        5: "Dirigeant ou membre de l'organe de direction d'une banque centrale ;",
        6: "Ambassadeur ou chargé d'affaires ;",
        7: "Officier général ou officier supérieur assurant le commandement d'une armée ;",
        8: "Membre d'un organe d'administration, de direction ou de surveillance d'une entreprise publique ;",
        9: "Directeur, directeur adjoint, membres du conseil d'une organisation internationale créée par un traité, ou une personne qui occupe une position équivalente en son sein.",
    },
    POLITICALLY_EXPOSED_OPTION_2_HELPER_TITLE:
        'II - Sont considérées comme des personnes réputées être des membres directs de la famille des personnes mentionnées au I :',
    POLITICALLY_EXPOSED_OPTION_2_HELPER_CONTENT: {
        1: 'Le conjoint ou le concubin notoire',
        2: "Le partenaire lié par un pacte civil de solidarité ou par un contrat de partenariat enregistré en vertu d'une loi étrangère ;",
        3: "Les enfants, ainsi que leur conjoint, leur partenaire lié par un pacte civil de solidarité ou par un contrat de partenariat enregistré en vertu d'une loi étrangère ;",
        4: 'Les ascendants au premier degré.',
    },
    POLITICALLY_EXPOSED_OPTION_3_HELPER_TITLE:
        'III - Sont considérées comme des personnes étroitement associées aux personnes mentionnées au I :',
    POLITICALLY_EXPOSED_OPTION_3_HELPER_CONTENT: {
        1: "Les personnes physiques qui, conjointement avec la personne mentionnée au I, sont bénéficiaires effectifs d'une personne morale, d'un placement collectif, d'une fiducie ou d'un dispositif juridique comparable de droit étranger ;",
        2: "Les personnes physiques qui sont les seuls bénéficiaires effectifs d'une personne morale, d'un placement collectif, d'une fiducie ou d'un dispositif juridique comparable de droit étranger connu pour avoir été établi au profit de la personne mentionnée au I ;",
        3: "Toute personne physique connue comme entretenant des liens d'affaires étroits avec la personne mentionnée au I.",
    },
    UN_LIEN_ENVOYE: 'Un lien de réinitialisation vous sera envoyé à cette adresse.',
    MONTANT_PLACEHOLDER: sum => `Minimum ${sum?.toLocaleString('fr')} €`,
    MONTANT_INFO: "Montant de l'investissement",
    MONTANT_NE_DOIT_PAS_ETRE_VIDE: 'Le montant ne doit pas être vide.',
    MONTANT_SOUSCRIT: 'Montant souscrit',
    MONTANT_VIREMENT: 'Montant du virement',
    MONTANT_APPELE: 'Montant appelé',
    MONTANT_PRELEVEMENT: 'Montant du prélèvement',
    MONTANT_TOTAL_SOUSCRIT: 'Montant total souscrit à présent\xa0:',
    MONTANT_TOTAL_APPELE: 'Montant total appelé à présent\xa0:',
    FUND_CALL_PERCENTAGE_ERROR: value =>
        `Le pourcentage saisi dépasse le ${value}\xa0% restant à appeler.`,
    MODIFIER_LES_RESPONSES: 'Modifier les réponses',
    ADD_CAPITAL_CALL: 'Ajouter un appel de fonds',
    MOT_DE_PASSE: 'Mot de passe',
    MOT_DE_PASSE_A_ETE_CHANGE: 'Le mot de passe a été changé.',
    MOT_DE_PASSE_OUBLIE: 'Mot de passe oublié',
    NOUVEAU_MOT_DE_PASSE: 'Nouveau mot de passe',

    CIVILITE: 'Civilité',

    OUI: 'Oui',
    NON: 'Non',

    NOM: 'Nom',
    REPRESENTATIVE_FULL_NAME: 'Prénom et nom du représentant légal',
    NATIONALITY: 'Nationalité',
    N_EST_PAS_ELIGILBLE: "Malheureusement vous n'êtes pas éligible et ne pouvez pas continuer.",
    NOMBRE_DE_PERSONNES_A_CHARGE: 'Nombre de personnes à charge, hors conjoint(e)',
    VOTRE_SOCIETE: 'Votre société',
    SIEGE_SOCIAL: 'Adresse du siège social',
    NO_OPTIONS: 'Aucune option disponible.',
    REPRESENTED_BY: 'Représentée par',
    YOU: 'Vous',
    EN_TANT_QUE: 'en tant que',
    ACTIVITE: 'Activité',
    DENOMINATION: 'Dénomination sociale',
    FORME_SOCIALE: 'Forme sociale',
    VERIFICATION: 'Verification',
    DISTRIBUTOR_SERVICER: 'Commercial Promoteur',
    ORGANISATION: 'Sous-distribution',
    RESEAU: 'Vous disposez de sous-distributeur(s) en France',
    INDEPENDANT: 'Vous ne disposez pas de sous-distributeur en France',
    CAPITAL_SOCIAL: 'Capital social',
    SIRET: 'Siret (ou équivalent)',
    SIREN_NUMBER: 'Numéro de SIREN',
    VAT_NUMBER: 'Numéro de TVA intracommunautaire',
    ORIAS_NUMBER: "Numéro d'immatriculation ORIAS",
    ORIAS_NUMBER_LENGTH: "Le numéro d'immatriculation ORIAS n'est pas valide",
    RCS_ADDRESS: "Lieu d'immatriculation au RCS",
    BIRTHPLACE: 'Lieu de naissance',
    RCS_DATE: "Date d'immatriculation au RCS",
    LEGAL_REPRESENTATIVE: 'Êtes-vous un représentant légal\xa0?',
    LEGAL_REPRESENTATIVE_LAST_NAME: 'Nom du représentant légal',
    LEGAL_REPRESENTATIVE_POSITION: 'Fonction du représentant légal',
    CONTACT_EMAIL: 'Email de contact',
    SIGNER_NAME: 'Nom du signataire',
    SIGNER_POSITION: 'Fonction du signataire',
    REPRESENTANT_LEGAL: 'Représentant légal',
    SIGNER: 'Signataire',
    CONVENTION: 'Convention',
    CONVENTION_TITLE: 'Convention(s)',
    GENERATE_CONVENTION: 'Générer la convention',
    ENVOYER_POUR_SIGNATURE: 'Envoyer pour signature',
    AWAITING_PARTNER_SIGNATURE: 'En attente de signature par le partenaire',
    AWAITING_PROVIDER_SIGNATURE: 'En attente de signature par AIFM',
    REQUESTED_BY_DISTRIBUTOR: 'Demande de convention',
    I_SIGN: 'Je signe',
    CHOOSE_USER: "Choisir l'utilisateur",
    CHOOSE_SIGNER: 'Choisir le signataire',
    MUST_CHOOSE_SIGNER: 'Vous devez choisir le signataire',
    SIGNED_BY_STAKEHOLDERS: 'Signée par les parties',
    POSITION: 'Fonction',
    REPRESENTATIVE_EMAIL: 'Adresse e-mail du représentant légal',
    REPRESENTATIVE_PHONE: 'Téléphone du représentant légal',
    YOUR_PHONE: 'Votre téléphone',
    YOUR_EMAIL: 'Votre adresse e-mail',
    RCS_NUMBER: 'Numéro RCS',
    REGIME_FISCAL: 'Régime fiscal',
    SIGNER_ON_KBIS: "signataire qui figure sur l'extrait K-bis (ou équivalent étranger)",
    SIGNER_QUALITY_1: "J'agis en qualité de (Président, Directeur Général…)",
    SIGNER_QUALITY_2: "J'agis en qualité de mandataire / fondé de pouvoir au nom de",
    MERCI_DE_TELECHARGER: 'Merci de télécharger le pouvoir du représentant légal signé',
    EN_SA_QUALITE: 'en sa qualité de (Président, Directeur Général…)',
    SIGNER_NOT_ON_KBIS: "signataire qui ne figure pas sur l'extrait K-bis (ou équivalent étranger)",
    SOUBSCRIBER_DECLARATION: 'Le Souscripteur déclare et garantit que\xa0:',
    SOUBSCRIBER_DECLARATION_OPT1:
        "la présente Souscription est faite pour son propre compte et qu'il sera le bénéficiaire effectif des parts souscrites ainsi que des revenus ou autres distributions du Fonds ; ou",
    SOUBSCRIBER_DECLARATION_OPT2:
        "la présente Souscription est faite pour le compte d'un investisseur qui sera le bénéficiaire effectif des parts souscrites ainsi que des revenus ou autres distributions du Fonds, auquel cas le Souscripteur déclare également que",
    SOUBSCRIBER_DECLARATION_OPT2_I:
        "(i) il est un organisme financier au sens de l'article L. 561-2 du CMF ou un établissement étranger équivalent,",
    SOUBSCRIBER_DECLARATION_OPT2_II:
        "(ii) qu'il existe au sein du Souscripteur des procédures de nature à lutter contre le blanchiment de capitaux et le financement du terrorisme permettant de satisfaire les diligences requises par les dispositions du Livre V, Titre VI du CMF et les textes pris pour leur application,",
    SOUBSCRIBER_DECLARATION_OPT2_III:
        "(iii) qu'il s'est conformé aux procédures visées au sous-paragraphe (ii) ci-avant et",
    SOUBSCRIBER_DECLARATION_OPT2_IV:
        "(iv) qu'il a fourni à la Société de gestion tout document écrit probant sur son identité, son statut et la véracité des déclarations visées aux sous-paragraphes (ii) et (iii) ci-avant.",

    NE_SEMBLE_PAS_ETRE_UN_NUMERO_DE_TELEPHONE: 'Cela ne semble pas être un numéro de téléphone.',
    PHONE_NUMBER_EXAMPLES: 'Exemples “06 73 47 53 11” ou “+33 673 453 11” ou “0673475311”.',
    VERIFIEZ_LE_NUMERO:
        'Si vous ne recevez pas un SMS avec un code de confirmation dans les 10 minutes, vérifiez le numéro de téléphone saisi.',

    NOM_DE_FAMILLE: 'Nom de famille',
    NOM_DE_NAISSANCE: 'Nom de naissance (si différent)',
    PRENOM: 'Prénom',
    PRENOMS: 'Prénom(s)',

    POUR_ACCEDER_A_VOTRE_COMPTE: 'pour accéder à votre compte.',
    POUR_RENVOYER_UN_NOUVEAU_EMAIL: 'pour renvoyer un nouvel email.',
    POUR_RECEVOIR_UN_NOUVEAU_EMAIL: 'pour recevoir un nouvel email.',
    POUR_VOUS_AUTHENTIFIER: ' pour vous authentifier.',
    CONFIRM_MODIFICATIONS: 'Modification des informations',
    QUIT_WITHOUT_FINISHING: 'Retour sans valider',
    CONFIRM_QUIT_VERIFICATION: 'Vous êtes en train de quitter cette étape. En êtes-vous sûrs\xa0?',
    CONFIRM_QUIT_SIGNATURE: 'Vous êtes en train de quitter sans avoir signé. Êtes-vous sûrs\xa0?',
    SAUVEGARDER_LES_CHANGEMENTS:
        'Vous avez modifié des informations. Est-ce que vous voulez sauvegarder les changements faits\xa0?',

    COUNTRY: 'Pays',
    PROFESSION: 'Profession',

    RECEVOIR_BIENTOT_EMAIL_DE_CONFIRMATION:
        'Nous vous envoyons un email pour valider votre compte.',
    SHOULD_CLOSE_PAGE: 'Vous pouvez désormais fermer cette page.',
    REINITIALISATION_DU_MOT_DE_PASSE: 'Réinitialisation du mot de passe',
    REINITIALISATION_DE_VOTRE_DE_PASSE: 'Réinitialisation de votre mot de passe',
    REINITIALISER_MOT_DE_PASSE: 'Réinitialiser le mot de passe',
    RENVOYER_LE_CODE: 'Renvoyer le code.',
    RESET_PASSWORD: 'Reset Password',
    FISCAL_RESIDENCE: 'Résidence fiscale',
    NIF: "Numéro d'identification fiscale (NIF)",
    CO_SUBSCRIBER_NIF: "Numéro d'identification fiscale co-souscripteur (NIF)",
    NIF_TABLE_HEADER: "Numéro d'Identification Fiscale",
    NUMERO_ID_FISCAL: "Numéro d'identification fiscale",
    FISCAL_REGIME_LABEL:
        'Option pour une imposition au régime fiscal français de personnes physiques\xa0:',
    FISCAL_OPTION_1: "L'investisseur ne souhaite pas bénéficier de l'exonération fiscale.",
    FISCAL_OPTION_2:
        "L'investisseur souhaite bénéficier de l'exonération fiscale au titre de l'article 163 quinquies B du Code général des impôts.",
    FISCAL_OPTION_2_INFO_1: sharesNo =>
        `L'Investisseur s'engage à conserver les ${sharesNo} Parts du Fonds souscrites pendant 5 (cinq) ans au moins à compter de leur souscription et opte pour le réemploi automatique et immédiat des sommes ou valeurs qui pourront être distribuées par le Fonds pendant cette période.`,
    FISCAL_OPTION_2_INFO_2:
        "L'investisseur reconnait que cette option est définitive et applicable uniquement aux personnes physiques qui sont résidentes fiscales de France au moment de la signature du bulletin de souscription des parts du fonds.",
    ROLE: 'Rôle',
    PROFILE: 'Profil',
    SAISIR_TOUS_LES_CHAMPS: 'Vous devez saisir tous les champs.',
    SAISIR_VOTRE_ADRESSE_EMAIL: 'Veuillez saisir votre adresse e-mail.',
    SAVE_AND_CONTINUE: 'Sauvegarder et continuer',

    SAVE: 'Sauvegarder',
    CREATE: 'Créer',
    SE_CONNECTER: 'Se connecter',
    SELECTIONNEZ_LE_ROLE: 'Sélectionnez le rôle',
    SETUP_PASSWORD: 'Setup Password',
    SIGN_IN: 'Sign In',
    SIGN_UP: 'Sign Up',
    SUBJECT: 'Sujet',
    SITUATION: 'Situation',
    SITUATION_PERSONNELLE: 'Situation personnelle',

    SUPPRIMER: 'Supprimer',
    SUBSTITUER: 'Substituer',
    IMPERSONATE_SUBSCRIBER: 'Vue souscripteur',
    IMPERSONATE_DISTRIBUTOR: 'Vue distributeur',
    STOP_IMPERSONATE_SUBSCRIBER: 'Arrêter la vue souscripteur',
    STOP_IMPERSONATE_DISTRIBUTOR: 'Arrêter la vue distributeur',
    DETAILS: 'Détails',
    REOPEN_TUNNEL: 'Réouverture du tunnel',
    RESEND_INVITATION: 'Renvoyer le lien',
    CONFIRM_REOPEN_TUNNEL: 'Etes-vous sûr(e) de vouloir rouvrir le tunnel\xa0?',
    GENERER_PEC: 'Générer le fichier PEC',

    TELEPHONE: 'Téléphone',
    TELEPHONE_NUMBER: 'Numéro de téléphone',
    INVALID_PHONE: 'Le numéro de téléphone est invalide',
    TUNNEL: 'Tunnel',
    UN_NOUVEAU_MESSAGE_VOUS_SERA_ENVOYE:
        'Un nouveau message vous sera envoyé. Merci de vérifier votre boîte.',
    SERVICER_USERS: 'Utilisateurs servicers / Animateurs',
    PROVIDER_USERS: 'Utilisateurs AIFM',
    PROVIDER: 'AIFM',
    PROVIDER_SIGNATORY: 'Signataire AIFM',
    PROVIDER_STANDARD: 'Standard AIFM',
    PROVIDER_ADMIN: 'Administrateur AIFM',
    ONGOING_SUBSCRIPTIONS: 'Souscriptions en cours',
    SUBSCRIPTION: 'Souscription',
    SUBSCRIPTIONS: 'Souscriptions',
    SUBSCRIPTIONS_BY_PARTNER: 'Souscriptions par Partenaire',
    QUICK_SEARCH: 'Rechercher',
    US_PERSON_TEXT_OPT1: 'un citoyen américain',
    US_PERSON_TEXT_OPT2: 'un résident fiscal américain.',
    US_PERSON: 'US Person',

    VEUILLEZ_CHOISIR_UNE_OPTION: 'Veuillez choisir une option',
    PASSWORD_REQUIRED: 'Veuillez entrer votre mot de passe pour continuer.',
    VEUILLEZ_SAISIR_VOTRE_NOM: 'Veuillez saisir votre nom de famille',
    LAST_NAME_LENGTH: 'Le nom doit comporter entre 2 et 120 caractères.',
    LAST_NAME_PATTERN: 'Votre nom ne doit pas contenir des caractères invalides',
    CO_SUBSCRIBER_LAST_NAME_PATTERN:
        'Le nom du co-souscripteur ne doit pas contenir des caractères invalides',
    VEUILLEZ_SAISIR_VOTRE_PRENOM: 'Veuillez saisir votre prénom',
    FIRST_NAME_LENGTH: 'Le prénom doit comporter entre 2 et 120 caractères.',
    FIRST_NAME_PATTERN: 'Votre prénom ne doit pas contenir des caractères invalides',
    CO_SUBSCRIBER_FIRST_NAME_PATTERN:
        'Le prénom du co-souscripteur ne doit pas contenir des caractères invalides',
    BIRTHNAME_PATTERN: 'Votre nom de naissance ne doit pas contenir des caractères invalides',
    FIELD_ILLEGAL_CHARACTER: 'Ce champ doit contenir uniquement des lettres.',
    SUM_RANGE_ELIGIBILITY: ({ name, minInvestedAmount, maxInvestedAmount }) =>
        `Les parts ${name} sont réservées aux investisseurs investissant un montant initial au moins égal à ${minInvestedAmount?.toLocaleString(
            'fr'
        )} € mais inférieur à ${maxInvestedAmount?.toLocaleString(
            'fr'
        )} € dans le Fonds (hors droits d'entrée).`,
    SUM_MIN_ELIGIBILITY: ({ name, minInvestedAmount }) =>
        `Les parts ${name} sont réservées aux investisseurs investissant un montant initial au moins égal à ${minInvestedAmount?.toLocaleString(
            'fr'
        )} € dans le Fonds (hors droits d'entrée).`,
    USE_CORRECT_AMOUNT:
        "Veuillez saisir un montant vous permettant de souscrire à ces parts ou contacter l'équipe Peqan",
    INCORRECT_INVESTMENT_AMOUNT:
        "Le montant de l'investissement ne correspond pas à l'option choisie.",

    VEUILLEZ_SAISIR_LE_CONTENU: "Veuillez saisir le contenu de l'email",
    VEUILLES_SAISIR_UN_SUJET: 'Veuillez saisir un sujet',
    VEUILLES_SAISIR_UN_MESSAGE: 'Veuillez saisir un message',
    VEUILLEZ_SAISIR_VOTRE_DATE_DE_NAISSANCE: 'Veuillez saisir votre date de naissance.',
    VEUILLEZ_SAISIR_VOTRE_VILLE_DE_NAISSANCE: 'Veuillez saisir votre ville de naissance.',
    VEUILLEZ_SAISIR_VOTRE_DEPARTEMENT_DE_NAISSANCE:
        'Veuillez saisir votre département de naissance.',
    VEUILLEZ_SAISIR_VOTRE_TELEPHONE: 'Veuillez saisir votre numéro de téléphone.',
    VEUILLEZ_SAISIR_VOTRE_ADDRESS: 'Veuillez saisir votre adresse.',
    FUTURE_DATE_VALIDATION: 'Vous ne pouvez pas choisir une date dans le futur.',
    VEUILLEZ_SAISIR_LE_CODE_POSTAL: 'Veuillez saisir le code postal.',
    VEUILLEZ_SAISIR_NIF_OR_MOTIF_ABSENCE_NIF: "Veuillez saisir le NIF ou un motif pour s'absence.",
    VEUILLEZ_SAISIR_TIN: 'Veuillez saisir votre TIN',
    VEUILLEZ_SAISIR_LA_VILLE: 'Veuillez saisir la ville.',
    VEUILLEZ_SAISIR_LE_NOMBRE_DE_PERSONNES:
        'Veuillez saisir le nombre de personnes à charge, hors conjoint(e).',
    VEUILLEZ_SAISIR_VOTRE_PROFESSION: 'Veuillez saisir votre profession.',

    VEUILLEZ_SAISIR_LE_MONTANT: 'Veuillez saisir le montant',
    VEUILLEZ_VERIFIER_VOTRE_RESPONSE:
        'Veuillez verifier votre réponse car elle ne correspond pas a ce produit.',
    VOTRE_RESPONSE_NE_CORESPONDE:
        'Votre réponse ne correspond pas à ce produit, vous pouvez la modifier ou abandonner.',
    VOTRE_RESPONSE_NE_SEMBLENT: 'Les réponses fournies semblent pour partie contradictoires.',
    INCOHERENT_ANSWER: 'Votre réponse ne semble pas être en cohérence avec les données fournies.',
    SUM_NOT_ENOUGH: "Le montant de l'investissement envisagé n'est pas suffisant.",
    PAUSE_AND_WAIT: 'Suspendre et être contacté',

    VILLE: 'Ville',
    VILLE_DE_NAISSANCE: 'Ville de naissance',

    VOUS_DEVEZ_ACCEPTER_LES_CONDITIONS: 'Vous devez accepter les Conditions générales',
    VOUS_DEVEZ_ACCEPTER_D_ETRE_CONTACTEE: "Vous devez accepter d'être contacté(e) par e-mail",
    VOUS_DEVEZ_SELECTIONNER_UNE_OPTION: 'Vous devez sélectionner une option',
    VOUS_DEVEZ_SELECTIONNER_TOUTE_OPTION: 'Vous devez sélectionner toute les options',
    VOUS_DEVEZ_REMPLIR_TOUS_CHAMPS: 'Vous devez remplir tous les champs',
    VOUS_DEVEZ_REMPLIR_LE_CHAMP: 'Vous devez remplir le champ',
    EFFECTIF_MIN: "L'effectif doit être supérieur à zéro.",

    VOTRE_COMPTE_N_EST_PAS_VALIDE:
        "Votre compte n'est pas valide. Merci de contacter la SGP pour plus de détails.",

    VOTRE_MESSAGE_A_ETE_ENVOYE: 'Votre message a été envoyé',
    VOTRE_MESSAGE: 'Votre message',
    ATTACHMENT_FILE: 'Fichier joint',

    VOTRE_EMAIL_A_ETE_VALIDE: 'Votre e-mail a été validé.',
    VOUS_VENEZ_DE_RECEVOIR_UN_CODE: 'Merci de saisir le code reçu par SMS dans la zone ci-dessous',
    MERCI: 'Merci',
    FINALIZATION: 'Finalisation',
    VEUILEZ_SAISIR_MOT_DE_PASSE: 'Veuillez saisir votre mot de passe de connexion.',
    MERCI_POUR_MOT_DE_PASSE:
        'Merci de saisir ci-dessous le mot de passe que vous allez utiliser pour vous authentifier.',
    POUVOIR_CONTINUER_LE_TUNNEL: 'Connectez-vous pour continuer votre souscription.',
    POUVOIR_CONTINUER_LE_TUNNEL_DISTRIBUTOR: 'Connectez-vous pour continuer votre inscription.',

    CONNEXION_EN_SUBSTITUTION: 'Connexion en substitution',
    CONNECT_AS: type =>
        `Connexion - vue ${type === 'subscriber' ? 'souscripteur' : 'distributeur'}`,
    ARRETER_SUBSTITUTION: 'Arrêter la connexion en substitution',
    VOULOIR_DECONNECTER: 'Êtes-vous sûrs de vouloir vous déconnecter?',
    VOULOIR_VOUS_CONNECTER: 'Êtes-vous sûrs de vouloir vous connecter en tant que',
    RETOUR: 'Retour',
    SUIVANT: 'Suivant',
    SIGN: 'Signer',
    NEXT_QUESTION: 'CLIQUER POUR PASSER À LA QUESTION SUIVANTE',
    SUIVANT_INFO_MESSAGE:
        'En cliquant sur le bouton “SUIVANT” vous avancez dans le parcours de souscription. \n' +
        "Ce bouton ne devient actif que lorsque l'ensemble des informations demandées a été fourni.",
    SUIVANT_CHECKBOX_MESSAGE: "J'ai compris. Pour continuer je coche la case.",
    ETAPE: 'Étape',
    ETAPES: 'Étapes',
    DATA_SAVED: 'Les données sont sauvegardées.',
    FORM_HAS_ERRORS: 'Il y a des erreurs dans le formulaire.',

    ROLE_SELECT_SUBTITLE:
        "Pour en savoir plus ou souscrire, nous devons mieux vous connaître et vérifier que vous disposez bien des compétences, de l'expérience et des connaissances nécessaires.",
    SELECTIONNEZ_PROFIL:
        'Pour débuter nous vous invitons à sélectionner votre profil investisseur.',
    FAIRE_VOTRE_CHOIX: 'Vouz devez faire votre choix avant de continuer',
    PERSONNE_MORALE: 'Personne morale',
    PERSONNE_PHYSIQUE: 'Personne physique',

    VOUS_DEVEZ_RESPONDE_TOUTE_QUESTION:
        'Vous devez répondre à toutes les questions avant de continuer',
    VOUS_DEVEZ_RESPONDRE_AU_MOINS_2_QUESTIONS: 'Vous devez répondre à au moins deux questions.',

    DIALOG_TITLE: 'Pourquoi cette question\xa0?',

    CHOISER_PART_AVANT: 'Merci de saisir le type de part avant de continuer',
    DEVEZ_SAISIR_CHAMP: 'Merci de saisir le montant de la souscription avant de continuer',
    TYPE_DE_PART: 'Type de parts\xa0:',
    MINIMUM_INVESTMENT: "L'investissement minimum pour cette part est de",
    EURO: '€',

    BANK_AND_FISCAL_INFO: 'Informations bancaires et fiscales',
    COORDONNEES_BANCAIRES: 'Vos coordonnées bancaires',
    EXTERNALLY_MANAGED: 'nominatif administré',
    MERCI_SAISIR_IBAN: 'Saisissez votre IBAN dans le champ ci-dessous.',
    BIC_LABEL: 'Saisissez votre BIC',
    BIC_ALT_LABEL: 'Saisissez le BIC',
    BIC_FORMAT_TITLE: 'Format du BIC',
    BIC_FORMAT_CONTENT: 'Le BIC doit contenir soit 8, soit 11 caractères.',
    SUBMIT_NEW_IBAN: 'Saisissez votre nouvel IBAN',
    ENTRUSTED_IBAN: "Saisissez l'IBAN du compte espèce du compte titre dans le champ ci-dessous.",
    ENTRUSTED_TITLE_IBAN: "Saisissez l'IBAN du compte titre dans le champ ci-dessous.",
    IBAN_INFO: "L'IBAN renseigné doit être celui du compte qui sera prélevé pour la souscription.",
    VALIDER: 'Valider',
    VALIDATION: 'Validation',
    INSCRIPTION_VALIDATION: "Validation de l'inscription",
    AT_LEAST_ONE_PROMOTER_FOR_VALIDATION:
        "Vous devez affecter au moins un promoteur pour valider l'inscription",
    AT_LEAST_ONE_PROMOTER: 'Vous devez affecter au moins un promoteur.',
    COMPLIANT: 'Conforme',
    NON_COMPLIANT: 'Non conforme',
    BANK_NAME: 'Nom de la banque:',
    IBAN: 'IBAN',
    BIC: 'BIC',
    MAX_ADMISSION_FEE: "Droits d'entrée maximum",
    FIRST_INSTALLMENT_PERCENTAGE: 'Pourcentage de la tranche initiale',
    INITIAL_COMMERCIALIZATION_DURATION: 'Durée de commercialisation initiale',
    FIRST_INSTALLMENT_DELAY: 'Appel de la tranche initiale',
    TAX_BASE: 'Assiette',
    NUMBER_OF_DECIMALS: 'Nombre de décimales',
    FISCAL: 'Fiscal',
    PROFESSIONAL: 'Professionnel',
    EXTERNALLY_MANAGED_LABEL: 'Nominatif administré',
    EXTERNALLY_MANAGED_BY: 'Administré par',
    ELIGIBLE_FOR_CONDITIONAL_SUM: 'Cas dérogatoire',
    CONVENTION_INFO: 'Informations pour la convention',
    ESSENTIAL_FUND_DOCUMENTS: 'Pièces constitutives',
    COLLECTION_DATE: 'Date de fin de collecte',
    ELIGIBLE_CUSTOMERS: 'Clientèle éligible',
    ELIGIBLE_COUNTRIES_WS: 'Territoire autorisé - avec sous-distributions',
    ELIGIBLE_COUNTRIES_WOS: 'Territoire autorisé - sans sous-distributions',
    CODE_BIC: 'Code BIC:',
    SAISIR_IBAN: "Vous devez saisir l'IBAN afin de pouvoir faire la validation",
    IBAN_PAS_VALIDE: "L'IBAN saisi n'est pas valide",
    IBAN_PROBLEM_DETECTED: "Problème détecté sur l'IBAN",
    IBAN_IS_THE_SAME: 'Vous devez saisir un IBAN différent de celui que vous utilisez actuellement',
    CODE_BIC_INVALID_CHARACTERS: 'Le BIC ne doit contenir que des caractères alphanumériques',
    BIC_INVALID: "Le BIC n'est pas valide",
    DIRECT_DEBIT_NOT_ALLOWED: "Le prelèvement n'est pas disponible sur ce compte bancaire",
    IBAN_REPLACE_PROBLEM:
        'Problème avec le compte bancaire choisi : contactez nous par mail à contact@petech.fr ou 01 42 89 12 87.',
    IBAN_VERIFICATION_PENDING: "La vérification de l'IBAN est en cours",
    IBAN_VALIDATION_PENDING: 'En attente de validation par la SGP',
    SAME_IBAN_NEW_RIB:
        "L'IBAN que vous avez fourni est déjà enregistré pour cette souscription. Le Relevé d'identité bancaire sera mis à jour avec le document que vous avez transmis.",
    SIGN_DIRECT_DEBIT_AUTHORIZATION: "Signer l'autorisation de prélèvement",
    YOU_CHOSE_DIRECT_DEBIT: 'Vous avez choisi de régler les appels de fonds par prélèvement.',
    YOU_CHOSE_CREDIT_TRANSFER: 'Vous avez choisi de régler les appels de fonds par virement.',
    PAYMENT_METHOD_DIALOG_TITLE: 'Modification du mode de règlement',
    CHANGE_TO_CREDIT_TRANSFER:
        'Êtes-vous sûrs de vouloir modifier le mode de règlement et payer les appels de fonds à venir par virement\xa0?',
    CHANGE_TO_DIRECT_DEBIT:
        'Êtes-vous sûrs de vouloir modifier le mode de règlement et payer les appels de fonds à venir par prélèvement\xa0?',
    CHANGE_TO_DIRECT_DEBIT_AFTER_COLLECTION_DATE:
        'Êtes-vous sûrs de vouloir modifier le mode de règlement en prélèvement\xa0?',
    ALREADY_SIGNED_DDA: 'Vous avez déjà signé une Autorisation de prélèvement.',
    NEED_TO_SIGN_DDA: 'Vous allez être amené à signer une Autorisation de prélèvement.',
    DIRECT_DEBIT: 'Prélèvement',
    CREDIT_TRANSFER: 'Virement',

    SAISIR_LE_PATRIMOINE: 'Merci de saisir le patrimoine global',
    HERITAGE_GREATER_THAN_0: 'Vos actifs doivent être supérieur à 0',
    SAISIR_LE_ENDETTEMENT: "Merci de saisir l'endettement total",
    SAISIR_LES_ACTIFS: 'Merci de saisir vos actifs',
    SAISIR_LES_PASSIF: 'Merci de saisir votre passif',
    REMPLIER_CETT_ENTREE: 'Veuillez remplir cette entrée',
    SAISIR_LES_POURCENTAGES: 'Merci de saisir les pourcentages',
    TOTAL_DES_POURCENTAGES: 'Le total des pourcentages doit être 100%',
    PERCENTAGE_VALUE: 'Le pourcentage doit être compris entre 0 et 100%',
    PERCENTAGE_VALUE_CUSTOM: (maxPercentage = 100) =>
        `Le pourcentage doit être compris entre 0 et ${maxPercentage}%`,
    CHOISIR_UNE_OPTION: 'Merci de choisir une option pour chaque ligne.',
    CHOISIR_OPTION: 'Merci de choisir une option.',
    JUSTIFICATIF_OBLIGATOIRE: 'Vous devez fournir le justificatif pour continuer.',

    DOWNLOAD_DOCUMENT: 'Télécharger le document',
    DOWNLOAD: 'Télécharger',
    CONSULTER: 'Consulter',
    DOWNLOAD_REGULATION: 'Télécharger le Règlement du Fonds',
    DOWNLOAD_REGULATION_SLP: 'Télécharger les statuts de la SLP',
    DOWNLOAD_REGULATION_FPS: 'Télécharger le Prospectus et le Règlement du Fonds',
    MUST_GO_THROUGH_REGULATIONS:
        "Vous devez avoir parcouru l'ensemble du Règlement du Fonds pour valider.",
    MUST_GO_THROUGH_REGULATIONS_FPS:
        "Vous devez avoir parcouru l'ensemble du Prospectus et du Règlement du Fonds pour valider.",
    MUST_GO_THROUGH_REGULATIONS_SLP:
        "Vous devez avoir parcouru l'ensemble des statuts de la SLP pour valider.",
    ACCEPTANCE_OF_REGULATIONS: 'Je déclare avoir pris connaissance du Règlement du Fonds.',
    ACCEPTANCE_OF_REGULATIONS_SLP:
        'Je déclare avoir pris connaissance des Statuts de la SLP et je déclare adhérer au Fonds et à ces Statuts.',
    ACCEPTANCE_OF_REGULATIONS_FPS:
        'Je déclare avoir pris connaissance du Prospectus et du Règlement du Fonds et je déclare y adhérer.',
    FUND_REGULATIONS_APAX:
        'Je consens à ce que les données recueillies par la Société de Gestion relatives à mon investissement dans le Fonds soient transmises à la société de gestion du Fonds Maître.',

    TELECHARGER_DICI: 'Télécharger le DIC',
    PARCOURIR_DICI:
        "Vous devez avoir parcouru l'ensemble du Document d'informations clés pour l'investisseur pour valider.",
    PARCOURIR_DICI_SLP: 'Vous devez avoir pris connaissance du DICI de la SLP pour valider.',
    COMPRIS_DICI: 'Je déclare avoir lu et compris le DIC.',

    ID_CHECK: "Vérification du document d'identité",
    PRIMARY_SUBSCRIBER_ID_CHECK: "Vérification du document d'identité du premier souscripteur",
    MAIN_SUBSCRIBER_ID_UPLOAD: "Document d'identité du premier souscripteur",
    CO_SUBSCRIBER_ID_UPLOAD: "Document d'identité du co-souscripteur",
    ID_UPLOAD: "Document d'identité",
    SECOND_ID_CHECK: "Vérification du deuxième document d'identité",
    ADDRESS_CHECK: 'Vérification du justificatif de domicile',
    DIRECT_DEBIT_AUTHORIZATION: "Signature de l'autorisation de prélèvement",
    SUBSCRIPTION_FORM_SIGNATURE: 'Signature du Bulletin de Souscription',
    SUBSCRIPTION_FORM_SIGNATURE_INVESTOR: 'Signature du Bulletin de Souscription souscripteur',
    SUBSCRIPTION_FORM_SIGNATURE_COSUBSCRIBER:
        'Signature du Bulletin de Souscription co-souscripteur',
    SUBSCRIPTION_FORM_GENERATION: 'Génération de votre Bulletin de Souscription',

    ATTEND_PROCESS: 'Votre document est en cours de vérification',
    DOCUMENT_VERIFIE: 'Votre document a été vérifié.',
    DOCUMENT_TYPE: 'Type de document',
    FRAME_ERROR: 'La vérification du document a échoué',
    RETRY: 'Réessayer',

    MONANT_SUPERIEUR: sum =>
        `Pour ce produit, le montant de votre investissement ne peut être inférieur à ${sum?.toLocaleString(
            'fr'
        )} €.`,

    ACCOUNT_CREATION: 'Création de votre compte',
    ESPACE_PEQAN_DEDIE:
        "Afin de disposer d'un espace dédié, veuillez renseigner les informations nécessaires à la création de votre compte.",
    ESPACE_PEQAN_DEDIE_SUCCESS:
        "Afin de finaliser la création de votre compte et disposer d'un espace dédié, veuillez consulter votre boîte mail renseignée précédemment afin d'activer votre compte.",

    ELIGIBILITEE_FCPR_SUBTITLE: isCompany =>
        `Pour pouvoir souscrire en tant que personne ${
            isCompany ? 'morale' : 'physique'
        } à un FCPR`,
    ELIGIBILITEE_Q2_INFO_TITLE: 'Client professionnel sur option',
    ELIGIBILITEE_Q3_INFO_TITLE:
        "A noter qu'en vous déclarant comme client professionnel sur option, vous déclarez posséder une expérience et des connaissances équivalentes à celles d'un professionnel et renoncez à une partie des protections apportées par la réglementation ainsi que les droits à indemnisations.",

    KYC_SURVEY: 'Vos revenus, patrimoine et investissement',
    KYC_ASSETS_PERCENTAGE_WARNING:
        'Les parts de Fonds de Capital Investissement français représentent plus de 10% dans les actifs.',
    STEP_5_SUBTITLE:
        "L'objectif de ce questionnaire est de déterminer votre connaissance des marchés financiers et votre capacité financière pour faire face aux risques liés à l'investissement dans le fonds",
    STEP_5_SUBTITLE_SLP:
        "L'objectif de ce questionnaire est de déterminer votre connaissance des marchés financiers et votre capacité financière pour faire face aux risques liés à l'investissement dans la SLP",
    VOTRE_CHIFFRE_D_AFFAIRES:
        "Votre chiffre d'affaires annuel net ou vos recettes annuelles nettes s'élèvent à",
    VOTRE_TOTAL_DU_BILAN: "Votre total du bilan s'élève à",
    VOS_CAPITAUX_PROPRES: "Vos capitaux propres s'élèvent à",
    VOTRE_EFFECTIF_1: 'Votre effectif est de',
    VOTRE_EFFECTIF_2: 'personnes',
    SAISIR_LE_CHAMP: 'Vous devez saisir ce champ avant de continuer.',
    INCORRECT_INPUT: "La valeur saisie n'est pas correcte",
    DIGIT_ERROR_MESSAGE: 'La valeur doit être comprise entre 0 et 9',
    INTEGER_NUMBER_ERROR: 'La valeur doit être un nombre entier',
    DATE_LESS_THAN: 'La date saisie doit être inférieure à celle choisie.',
    FILE_MISSING: 'Vous devez fournir un document pour continuer',
    REVENUS: 'Revenus',
    REVENUS_P1:
        'Compte tenu du profil de risque du fonds, il est conseillé de ne pas engager plus de 10% de ses revenus (ou patrimoine financier) dans ce type de fonds.',
    REVENUS_P2: 'Ces informations sont indicatives.',
    REVENUS_P3:
        'Le revenu annuel net est considéré avant éventuel prélèvement des impôts à la source.',
    SOURCE_PRINCIPALE: 'Source principale des revenus',
    SOURCE_PRINCIPALE_INFO:
        "L'indication de la source principale de revenu permet de qualifier le type de ressource dont vous disposez.",
    PATRIMOINE_GLOBAL: 'Patrimoine global',
    PATRIMOINE_INFO_1:
        'Ces informations doivent refléter la ventilation de votre patrimoine lors de la souscription.',
    PATRIMOINE_INFO_1_PM:
        'Ces informations doivent refléter la ventilation du patrimoine de la personne morale lors de la souscription.',
    PATRIMOINE_INFO_2: 'La somme des pourcentages doit être égale à 100%.',
    INSTRUMENTS_FINANCIERS: 'Instruments financiers',
    INSTRUMENTS_FINANCIERS_INFO:
        "Le type d'instruments financiers détenus permet de déterminer votre expérience des différents marchés financiers.",
    INVESTISSEMENTS_REALISES: 'Investissements réalisés',
    INVESTISSEMENTS_REALISES_INFO:
        "Les investissements réalisés sur les 12 derniers mois permettent de préciser votre fréquence d'intervention sur les marchés financiers.",
    INVESTISSMENTS_NON_COTE:
        'Il convient de répondre « Oui » si dans le cadre de vos investissements non cotés réalisés vous détenez des parts de fonds de capital investissement français ou leur équivalent étranger (ex: RAIF luxembourgeois).',
    PAS_DE_FONDS_DE_CAPITAL:
        'Si vous ne détenez pas de fonds de capital investissement à ce jour, il convient de répondre « Non ».',

    INVESTMENT_EXPERIENCE: 'Dans le cadre de vos investissements financiers, vous avez : ',
    TRANSACTIONS_EXPERIENCE:
        'Nombre de transactions réalisées sur du non côtés au cours des 12 derniers mois : ',
    FIELD_REQUIRED: 'Vous devez saisir le champ avant de continuer',

    DICI: "Document d'informations clés pour l'investisseur",
    MERGED_DICI: 'DICI fusionné',

    COPYRIGHT: 'PE Tech COPYRIGHT ©',
    CONTACT: 'contact.',
    MENTIONS_LEGALES: ' Mentions légales.',
    POLICY: ' Politique de confidentialité.',

    DATE_ENTREE: "Date d'entrée",
    DATE: 'Date',
    MONTANT: 'Montant',
    MIN_SUM: 'Montant minimum',
    MAX_SUM: 'Montant maximum',
    PERCENTAGE: 'Pourcentage',
    MIN_PERCENTAGE: 'Pourcentage minimum',
    MAX_PERCENTAGE: 'Pourcentage maximum',
    MONTANT_INVESTI: 'Montant investi',
    PRODUIT: 'Produit',
    PAYMNENT_METHOD: 'Mode de règlement',
    PAYMENT: 'Paiement',
    CONFIRMED: 'Soldé',
    PENDING: 'En attente',
    COMPLY_ADVANTAGE_STATUS: 'Status ComplyAdvantage',
    PRODUITS: 'Produits',
    PARTNER: 'Partenaire',
    PARTNERS: 'Partenaires',
    CONSULTANT: 'Conseiller',
    TRANSFERRED_AT: 'Transféré de',
    CONSULTANT_EMAIL: 'Conseiller E-mail',
    CONSULTANT_PHONE: 'Conseiller numéro de téléphone',
    CATEGORIE_DE_PARTS: 'Catégorie de parts',
    CATEGORIE: 'Catégorie',
    CATEGORIES: 'Catégories',
    ETAPE_ACTUELLE: 'Étape actuelle',
    ETAPE_TUNNEL: 'Étape du tunnel',
    EXPORTER_LISTE: 'Exporter la liste',
    EXPORT: 'Exporter',
    EXPORT_PDF: 'Télécharger PDF',
    EXPORT_DISTRIBUTORS: 'Exporter les distributeurs',
    EXPORT_USERS: 'Exporter les utilisateurs',
    SEND_MESSAGE_TO_LIST: 'Envoyer un message à la liste',
    FILTRES: 'Filtres',
    DISTRIBUTEUR: 'Distributeur',
    PEQAN: 'Peqan',
    PEQAN_TEAM: "L'équipe Peqan",
    CHERE: 'Cher(e)',
    LINK: 'lien',
    SITE: 'site',
    CHANGE_PARTNER: 'Modification du partenaire',
    CONSULTANT_REQUIRED: 'Vous devez choisir un conseiller pour continuer.',
    SEARCH_FOR_PARTNER: 'Recherchez un partenaire',
    CHANGE_MANAGER: 'Modifier le commercial',
    SEARCH_FOR_SERVICER: 'Recherchez un commercial',
    SERVICER_MANAGER_REQUIRED: 'Merci de choisir le commercial afin de pouvoir sauvegarder',

    PRENOM_NE_CORRESPOND_PAS:
        'Votre prénom extrait du document fourni ne correspond pas avec votre saisie. Merci de revenir à la première étape et le modifier.',
    ID_INELIGIBILE:
        "La vérification du document d'identité a échoué. Malheureusement, vous n'êtes pas éligible et ne pouvez pas continuer.",
    DOCUMENT_VERIFIE_AVEC_INCOHERENCES: 'Votre document a été vérifié et il y a des incohérences.',
    MERCI_REESSAYER: ' Merci de réessayer.',

    MERCI_DEBUT: 'Merci',
    POUR_INTERET_1: "de l'intérêt porté à nos produits, n'hésitez à nous contacter par mail à",

    MONTANT_SOUSCRIPTION: 'Montant de la souscription',
    VALEUR_PART: 'Valeur de la part',
    NOMBRE_PARTS_FOND: 'Nombre de parts du Fonds',
    SHARES_NUMBER: 'Nombre de parts',
    COMMISION_SOUSCRIPTION: 'Commission de souscription',
    SUBSCRIPTION_COMMISSION_VALUE: 'Montant de la commission de souscription',
    ADMISSION_FEE: "Droits d'entrée",
    ADMISSION_FEES: "Frais d'entrée",
    MONTANT_DE_DROITS_DE_ENTREE: "Montant des droits d'entrée",
    MONTANT_D_ENGAGEMENT: "Montant total de l'investissement",
    ADD_CATEGORY: 'Ajouter une catégorie',
    ADD_SUBCATEGORY: 'Ajouter une sous-catégorie',
    DELETE_CATEGORY: 'Supprimer la catégorie',
    CONFIRM_DELETE_CATEGORY:
        'Êtes-vous sûrs de vouloir supprimer cette catégorie avec les sous-catégories affectées\xa0?',
    DELETE_SUBCATEGORY: 'Supprimer la sous-catégorie',
    CONFIRM_DELETE_SUBCATEGORY: 'Êtes-vous sûrs de vouloir supprimer cette sous-catégorie\xa0?',
    AVAILABLE_FROM: 'Disponible de\xa0:',
    AVAILABLE_TO: "Disponible jusqu'à\xa0:",
    CATEGORY_NAME_PATTERN:
        'Le nom de la catégorie doit avoir seulement des caractères alphanumériques, sans des caractères spéciaux.',

    // Share subcategory fields
    SUBCATEGORY_NAME: 'Nom de la sous-catégorie',
    SHARE_VALUE: 'Valeur de la part',
    NOMINAL_SHARE_VALUE: 'Valeur nominale de la part',
    MANAGEMENT_FEE: 'Frais de gestion',
    EXIT_FEE: 'Droits de sortie',
    PERFORMANCE_FEE: 'Frais de performance',
    MAX_DISTRIBUTOR_ADMISSION_FEE: "Droits d'entrée maximum distributeur",
    MAX_DISTRIBUTOR_ADMISSION_FEE_ERROR:
        "La valeur ne doit pas dépasser le pourcentage des droits d'entrée",
    IMMEDIATE_PAYMENT: 'Paiement immédiat',
    DISTRIBUTOR_MANAGEMENT_FEE: 'Frais de gestion distributeurs',
    SUBSCRIPTION_FEE: 'Commission de souscription',
    MIN_INVESTED_AMOUNT: 'Montant minimum',
    MAX_INVESTED_AMOUNT: 'Montant maximum',
    DICI_LABEL: 'DICI',
    ISIN_CODE: 'Code ISIN',
    DEBIT_TRANSFER: 'Prélèvement',
    ACCESSIBLE_TO_DISTRIBUTION: 'Accessible à la distribution',

    ECRIVEZ_MONTANT_EN_TOUTES_LETTRES:
        'Écrivez le montant total de la souscription en toutes lettres',
    INITIAL_SLICE_AMOUNT: 'Versement de la tranche initiale',
    INITIAL_SLICE_AMOUNT_TITLE: 'Montant de la tranche initiale',
    NO_DATA_AVAILABLE: 'Aucune donnée disponible',
    INITIAL_SLICE_AMOUNT_INFO: (amount, delay) =>
        `La tranche initiale sera appelée ${delay} jours après signature du bulletin de souscription par la société de gestion. Elle comprend ${amount}% du montant de l'investissement et les droits d'entrée éventuels.`,

    NUMERO_FISCAL: `Le Numéro d'Identification Fiscale (« NIF ») est un numéro d'identification attribué aux contribuables par l'administrations fiscale. Il se situe sur vos différents avis d'impositions. (13 chiffres commençant par 0,1,2 ou 3)`,

    // ---- ERROR TOAST MESSAGES ----
    ERROR_400: 'Mauvaise demande au serveur.',
    ERROR_401:
        'Votre session a expiré. Vous avez été automatiquement déconnecté pour des raisons de sécurité. Veuillez vous reconnecter pour continuer.',
    ERROR_403: 'Accès interdit aux ressources.',
    ERROR_500: 'Erreur serveur.',
    ERROR_GENERAL: "Désolé, nous rencontrons un problème. \nMerci de contacter l'équipe Peqan.",

    // ---- Subscription Alerts ----
    EMPTY_RESPONSE: field => `Réponse vide de Jumio pour le champ : ${field}`,
    PRENOME_NE_CORRESPOND_ADMIN:
        "Le prénom extrait du document d'identité ne correspond pas à la saisie.",
    NOME_NE_CORRESPOND_ADMIN:
        "Le nom extrait du document d'identité ne correspond pas à la saisie.",
    SANCTIONS_ADMIN: 'Le souscripteur figure sur une liste de sanctions.',
    SECOND_DOCUMENT_PRENOME_ADMIN:
        "Le prénom extrait du 2ème document d'identité ne correspond pas à la saisie.",
    SECOND_DOCUMENT_NOME_ADMIN:
        "Le nom extrait du 2ème document d'identité ne correspond pas à la saisie.",
    DOCUMENT_PAS_VALIDE: "Le document d'identité n'est pas valide.",
    MANUAL_ID_UPLOAD: "Vérification manuelle du document d'identité",
    SECOND_DOCUMENT_INVALID_ADMIN: `La vérification du 2ème document d'identité n'a pas réussi.`,
    PREMIER_DOCUMENT_DIFFERENT_ADMIN:
        "Pour la première pièce d'identité, le souscripteur doit la soumettre de nouveau car les pièces d'identité vérifiées doivent être différentes.",
    SECOND_DOCUMENT_DIFFERENT_ADMIN:
        "Pour la 2ème pièce d'identité, le souscripteur doit la soumettre de nouveau car les pièces d'identité vérifiées doivent être différentes.",
    DOMICILE_PAS_REUSSI_ADMIN: "La vérification du justificatif de domicile n'a pas réussi.",
    NOME_NE_CORRESPOND_SOUSCRIPTEUR_ADMIN:
        'Le nom extrait du justificatif de domicile ne correspond pas à la saisie.',
    PRENOME_NE_CORRESPOND_SOUSCRIPTEUR_ADMIN:
        'Le prénom extrait du justificatif de domicile ne correspondent pas à la saisie.',
    JUSTIFICATIF_DE_DOMICILE_ADMIN:
        'Le justificatif de domicile que le souscripteur a fourni doit être de moins de 3 mois.',
    CODE_POSTAL_NE_CORRESPONDENT_ADMIN:
        'Le code postal et la ville extraits du justificatif de domicile ne correspondent pas à la saisie.',
    ADRESSE_NE_CORRESPOND_ADMIN:
        "L'adresse extraite du justificatif de domicile ne correspond pas à la saisie.",
    REDO_ADDRESS_CHECK_AFTER_ADDRESS_CHANGE_ADMIN:
        "Le justificatif de domicile doit être vérifié de nouveau, parce que l'adresse a été changée.",
    REDO_ADDRESS_CHECK_AFTER_NAME_CHANGE_ADMIN:
        'Le justificatif de domicile doit être vérifié de nouveau, parce que le nom/prénom a été changé.',
    REDO_ID_CHECK_ADMIN:
        "Le document d'indentité doit être vérifié de nouveau, parce que le nom/prénom a été changé.",
    REDO_SECOND_ID_CHECK_ADMIN:
        "Le 2ème document d'indentité doit être vérifié de nouveau, parce que le nom/prénom a été changé.",
    SECOND_ID_CHECK_INCOMPLETE_ADMIN:
        "Le souscripteur doit vérifier un deuxième document d'identité afin de pouvoir signer le bulletin de souscription.",
    VERIFICATION_IDENTITE_ADMIN: "La vérification du document d'identité est en cours.",
    SECOND_VERIFICATION_IDENTITE_ADMIN: "La vérification du 2ème document d'identité est en cours.",
    VERIFICATION_DOMICILE_ADMIN: 'La vérification du justificatif de domicile est en cours.',
    OTHER_CURRENCY: "Capital social autre que l'euro.",
    OTHER_BENEFICIARY:
        "Souscription faite pour le compte d'un investisseur qui sera le bénéficiaire effectif.",
    RESIDENCE_OUTSIDE_FRANCE: 'Résidence fiscale autre que la France.',
    RESIDENCE_OUTSIDE_FRANCE_CO_SUBSCRIBER:
        'Résidence fiscale autre que la France pour le co-souscripteur.',
    US_PERSON_ALERT: 'US Person',
    OTHER_INCOME: 'Source principale des revenus - Autres.',
    PEP_ALERT: 'Personne politiquement exposée.',
    PEP_CO_SUBSCRIBER_ALERT: 'Le co-souscripteur - personne politiquement exposée.',
    PEP_USER: 'Le souscripteur / le représentant figure sur des listes PEP',
    PEP_CO_SUBSCRIBER: 'Le co-souscripteur figure sur des listes PEP',
    PEP_COMPANY: 'La compagnie figure sur des listes PEP',
    SANCTIONS_USER: 'Le souscripteur / le représentant figure sur des listes de sanctions',
    SANCTIONS_CO_SUBSCRIBER: 'Le co-souscripteur figure sur des listes de sanctions',
    SANCTIONS_COMPANY: 'La compagnie figure sur des listes de sanctions',
    PEP_COMPLY_ADVANTAGE_ALERT:
        'Attention! Présence soit sur la liste des sanctions ou / et PEP pour le souscripteur.',
    PEP_COMPLY_ADVANTAGE_ALERT_BENEFICIAIRE:
        'Attention! Présence soit sur la liste des sanctions ou / et PEP pour le(s) bénéficiaire(s).',
    PEP_COMPLY_ADVANTAGE_ALERT_CO_SUBSCRIBER:
        'Attention! Présence soit sur la liste des sanctions ou / et PEP pour le co-souscripteur.',
    PEP_DISTRIBUTOR_USER: 'Le signataire figure sur des listes PEP',
    SANCTIONS_DISTRIBUTOR_USER: 'Le signataire figure sur des listes de sanctions',
    PEP_DISTRIBUTOR_REPRESENTATIVE: 'Le représentant légal figure sur des listes PEP',
    SANCTIONS_DISTRIBUTOR_REPRESENTATIVE:
        'Le représentant légal figure sur des listes de sanctions',
    HERITAGE_LESS_THAN_INVESTMENT: 'Le patrimoine global est inférieur au montant investi.',
    INCOME_LESS_THAN_10: 'Revenu moyen annuel net inférieur à 10% du montant souscrit.',
    NO_FINANCIAL_INSTRUMENT: 'Aucun instrument financier détenu.',
    NO_INCOME_RISK:
        "Le souscripteur n'est pas prêt(e) à prendre le risque d'absence de revenus et de perte en capital lié à l'investissement dans le Fonds.",
    OBJECTIVES_NOT_SYNCED:
        "Les objectifs d'investissement ne semblent pas en adéquation avec le profil de risque du produit.",
    FUNDS_LOSS_EFFECT:
        "Le souscripteur n'est pas en mesure de perdre la totalité de son investissement dans le Fonds sans que cela compromette sa situation financière.",
    ID_EXPIRED: "Le document d'identité est expiré.",
    SECOND_ID_EXPIRED: "Le deuxième document d'identité est expiré.",
    AFFIDAVIT_UPLOADED: "Attestation sur l'honneur complété.",
    REDO_DIRECT_DEBIT_AUTHORISATION_ADDRESS:
        "L'autorisation de prélèvement doit être signée de nouveau parce que le souscripteur a changé l'adresse.",
    REDO_DIRECT_DEBIT_AUTHORISATION_RIB:
        "L'autorisation de prélèvement doit être signée de nouveau parce que le souscripteur a changé le RIB.",
    REDO_DIRECT_DEBIT_AUTHORISATION_NAME:
        "L'autorisation de prélèvement doit être signée de nouveau parce que le souscripteur a changé son nom ou prénom.",
    UNLISTED_FINTECH:
        "Investisseur - établissement de crédit, une entreprises d'assurances, un fonds de retraite professionnelle, une mutuelle ou une entreprise d'investissement.",
    LISTED_COMPANY:
        "Investisseur - société cotées dont les titres sont admis à la négociation sur au moins un marché réglementé en France ou dans l'EEE",
    PUBLIC_AUTHORITY: 'Investisseur - autorité publique',
    BENEFICIARY_LISTED_COMPANY:
        "Bénéficiaire effectif - société cotées dont les titres sont admis à la négociation sur au moins un marché réglementé en France ou dans l'EEE.",
    BENEFICIARY_PUBLIC_AUTHORITY: 'Bénéficiaire effectif - autorité publique.',
    NUMERO_FISCAL_SAISI: "Le numéro d'identification fiscale n'est pas saisi par le souscripteur.",
    CO_SUBSCRIBER_NUMERO_FISCAL_SAISI:
        "Le numéro d'identification fiscale n'est pas saisi par le co-souscripteur.",
    SOUSCRIPTION_INITIALE:
        "Le souscripteur avec une souscription initiale d'au moins 30 000 euros.",
    SOUSCRIPTION_DEPASSE:
        'Le montant de la souscription dépasse 50% de la valeur du patrimoine global.',
    FUNDS_ORIGIN_OTHER: "Le souscripteur a choisi Autres pour l'origine des fonds.",
    JUMIO_EMPTY_RESPONSE: "La vérification du document n'a pas réussi.",
    // -----------------------------

    YOU_HAVE_INVESTED: 'vous avez souscrit un montant de',
    REPRESENTING: 'représentant',
    FUND_SHARES: 'parts du fonds',
    INTO_THE_FUND: 'dans le fonds',
    COMMERCIALISED_BY: 'commercialisé par',
    SGP_WILL_PROCEED:
        "La société de gestion va procéder à l'étude de la conformité de votre demande de souscription.",
    SGP_WILL_SEND_EMAIL:
        "Après acceptation vous recevrez un email afin de procéder au paiement, conformément à l'article 10.2 du règlement du fonds ",
    SGP_SIGNATURE_FOLLOWING_PAYMENT:
        'le versement de votre souscription dans les délais impartis donnera lieu à la contre signature de votre Bulletin de Souscription par la société de gestion.',

    SIGNED_BY_SGP: 'Dès que le BS sera signé, vous recevrez un e-mail de confirmation.',
    READY_TO_SIGN_BY_SGP: 'Prêt à signer par la SGP',
    READY_TO_BE_VERIFIED: 'VERIFIÉ',
    DISTRIBUTOR_VERIFICATION: 'Vérification distributeur',
    VERIFICATION_TEXT: (name, date) => `Vérifié par ${name} le ${date}.`,
    VERIFICATION_ERROR_TEXT: name => `Vérification faite par ${name}, veuillez actualiser la page.`,
    TERMINER: 'Terminer',

    AUTHORISATION_REFUSEE: "Vous avez refusé de signer l'autorisation de prélèvement.",
    AUTHORISATION_SUCCESS: "Vous avez signé l'autorisation de prélèvement.",
    SIGNATURE_ERROR: 'Nous avons rencontré des difficultés techniques.',
    BULLETIN_REFUSEE: 'Vous avez refusé de signer le bulletin de souscription.',
    BULLETIN_SUCCESS: 'Vous avez signé le bulletin de souscription',
    BULLETIN_GENERATING: 'Le bulletin de souscription est en cours de génération',
    PLEASE_WAIT: 'Veuillez patienter, ',
    WAIT_TO_SIGN: 'vous allez pouvoir bientôt signer votre bulletin de souscription',
    PLEASE_SIGN: 'Pour finaliser votre souscription merci de signer votre bulletin de souscription',
    MANDATORY_FORM: 'Mentions obligatoires',
    BS_CHECKBOX_LABEL_1: "En cochant la présente case, l'Investisseur reconnaît :",
    BS_CHECKBOX_LABEL_1_PARAGRAPH_1:
        "que le présent Bulletin de Souscription est signé électroniquement par le représentant habilité de l'Investisseur par le biais du service Yousign, conformément aux articles 1366 et 1367 du code civil ;",
    BS_CHECKBOX_LABEL_1_PARAGRAPH_2:
        "qu'une signature électronique via Yousign, lequel service est conforme au règlement eIDAS (UE) 910/2014, a été utilisée pour la signature du présent Bulletin de Souscription par l'Investisseur ;",
    BS_CHECKBOX_LABEL_1_PARAGRAPH_3:
        "qu'il a reçu toutes les informations requises pour la signature électronique du présent Bulletin de Souscription et qu'il a signé le présent Bulletin de Souscription par voie électronique en toute connaissance de la technologie utilisée et de ses conditions générales, et renonce par conséquent à toute réclamation et/ou action en justice afin de remettre en cause la fiabilité de ce système de signature électronique et/ou son intention de conclure le présent Bulletin de Souscription ;",
    BS_CHECKBOX_LABEL_1_PARAGRAPH_4:
        "que, conformément aux dispositions de l'article 1375 du code civil, l'obligation de remise d'un exemplaire original papier à l'Investisseur et à la Société de Gestion n'est pas nécessaire comme preuve de leur engagement et de leurs obligations ;",
    BS_CHECKBOX_LABEL_1_PARAGRAPH_5:
        "que la remise d'une copie électronique du présent Bulletin de Souscription directement par Yousign à l'Investisseur et à la Société de Gestion constitue une preuve suffisante et irréfutable de leurs engagements et obligations .",
    BS_CHECKBOX_LABEL_2_FCPR: (subcategory, fullName, gender) =>
        `${fullName} reconnait ${gender === 'f' ? "qu'elle" : "qu'il"} a été averti${
            gender === 'f' ? 'e' : ''
        } que la souscription ou l'acquisition des Parts ${
            subcategory.name
        } du Fonds, directement ou par personne interposée, est réservée aux Porteurs de Parts éligibles conformément à l'article 6.2 du Règlement.`,
    BS_CHECKBOX_LABEL_2_FPCI: (subcategory, fullName, gender) =>
        `${fullName} reconnait ${gender === 'f' ? "qu'elle" : "qu'il"} a été averti${
            gender === 'f' ? 'e' : ''
        } que la souscription ou l'acquisition des Parts ${
            subcategory.name
        } du Fonds, directement ou par personne interposée, est réservée aux Investisseurs Avertis, tel que ce terme est défini dans le Règlement.`,
    BS_CHECKBOX_LABEL_2_FPS: (subcategory, fullName, gender) =>
        `${fullName} reconnait ${gender === 'f' ? "qu'elle" : "qu'il"} a été averti${
            gender === 'f' ? 'e' : ''
        } que la souscription ou l'acquisition des Parts ${
            subcategory.name
        } du Fonds, directement ou par personne interposée, est réservée aux Investisseurs Avertis, tel que ce terme est défini dans le Règlement.`,
    BS_CHECKBOX_LABEL_2_SLP:
        "Conformément au Règlement Général de l'Autorité des marchés financiers, l'Investisseur, en cochant cette case, reconnait par écrit que le Fonds est strictement réservé aux Investisseurs Avertis tels que défini dans l'Avertissement des Statuts.",
    BS_CHECKBOX_LABEL_3_FPCI: (subcategory, fullName, gender) =>
        `${fullName} reconnait ${gender === 'f' ? "qu'elle" : "qu'il"} a été averti${
            gender === 'f' ? 'e' : ''
        } que la souscription ou l'acquisition des Parts ${
            subcategory.name
        } du Fonds, directement ou par personne interposée, est réservée aux Investisseurs Avertis, tel que ce terme est défini dans le Règlement.`,
    BS_CHECKBOX_LABEL_3_FCPR: (subcategory, fullName, gender) =>
        `${fullName} reconnait ${gender === 'f' ? "qu'elle" : "qu'il"} a été averti${
            gender === 'f' ? 'e' : ''
        } que la souscription ou l'acquisition des Parts ${
            subcategory.name
        } du Fonds, directement ou par personne interposée, est réservée aux Investisseurs Avertis, tel que ce terme est défini dans le Règlement.`,
    MOINS_UNE_CASE: 'Merci de cocher au moins une case pour continuer',

    ACCUEIL: 'Accueil',
    MY_PORTFOLIO: 'Mon portefeuille',
    AS_OF: 'au',
    BONJOUR: 'Bonjour',
    BIENVENUE_ESPACE_PERSONNEL: 'Bienvenue dans votre espace personnel.',
    TOTAL_ENGAGEMENTS: 'TOTAL DES ENGAGEMENTS',
    ON_FUND: fundName => `Dans le fonds ${fundName}`,
    LATEST_VALORIZATION: 'DERNIÈRE VALORISATION',
    NON_PRO_CLIENT: 'Client non professionnel',
    PRO_CLIENT: 'Client professionnel',
    TOTAL_TRANSFERS: 'Total virements',
    HISTORIQUE_INVESTISSEMENTS: 'Historique des flux',
    MEMBER_SINCE: 'Membre depuis le',
    INFO_ATTESTATION_SUR_HONNEUR:
        "En cas de justificatif de domicile au nom d'un tiers, nous vous invitons à\xa0:",
    INFO_ATTESTATION_SUR_HONNEUR_OPTION_1:
        "1- Télécharger et compléter l'attestation sur l'honneur\xa0:",
    INFO_ATTESTATION_SUR_HONNEUR_OPTION_2:
        "2- Déposer l'attestation sur l'honneur dûment complétée et signée:",
    DOCUMENT_ATTESTATION_SUR_HONNEUR: "document d'attestation sur l'honneur",
    UPLOAD_FILE_BUTTON: 'Parcourir',
    DOWNLOAD_FILE_BUTTON: 'Télécharger',
    UPLOADED_FILE_NAME: 'Fichier sélectionné',
    UPLOADED_ATTESTATION_SUR_HONNEUR_SUCCESS:
        "L'attestation sur l'honneur a été téléchargé avec succès.",
    AUCUN: 'Aucun',

    INVESTORS: 'Investisseurs',
    CLIENT_ACCOUNTS: 'Comptes clients',
    INVESTMENT_DATE: "Date de l'investissement",
    SUBSCRIPTION_DATE: 'Date souscription',
    LAST_LOGIN_DATE: 'Date de la dernière connexion',
    ONLINE: 'En ligne',
    FAX: 'Fax',
    FINISHED_SUBSCRIPTIONS: 'Souscriptions réalisées',
    FINISHED: 'Réalisées',
    ACCOUNT_SITUATION: 'Situation de compte',
    PORTFOLIO: 'PORTEFEUILLE',

    KBIS: 'Téléchargement KBIS',
    MERCI_KBIS: 'Merci de nous fournir le KBis (ou équivalent étranger).',
    FERA_OBJET: "A noter que celui-ci fera l'objet d'une vérification complémentaire. ",
    REVIENDROS: 'Nos conseillers reviendront vers vous le cas échéant.',

    STATUTS: 'Statuts à jour du souscripteur',
    MERCI_STATUTS: 'Merci de nous fournir les derniers statuts à jour.',
    FILE_TYPE_INCORRECT: 'Le type de fichier téléchargé ne correspond pas.',
    FILE_TOO_LARGE: 'Le fichier que vous avez téléchargé dépasse la limite de 10MB.',
    TYPE_DU_FICHIER: "Le type du fichier n'est pas bon.",

    VIGILANCE_INVESTOR: "Cas de vigilance réduite pour l'investisseur",
    VIGILANCE_INVESTOR_LABEL_1:
        "Etes vous un établissement de crédit, une entreprises d'assurances, un fonds de retraite professionnelle, une mutuelle ou une entreprise d'investissement\xa0?",
    VIGILANCE_INVESTOR_LABEL_2:
        "Etes vous une société cotée dont les titres sont admis à la négociation sur au moins un marché réglementé en France ou dans l'EEE ? ",
    VIGILANCE_INVESTOR_LABEL_3: 'Etes-vous une autorité publique ? ',
    STATUS_UPLOAD_FILE:
        'Merci de fournir tous les documents permettant de justifier de votre statut au regard des questions ci-dessus (optionnel).',
    IMMATRICULEE_EN_FRANCE: 'immatriculée en France',
    NUMERO_RCS: "Numéro RCS et ville d'immatriculation",
    RELVE_DE_LA_LEGISLATION:
        "relève de la législation d'un autre État membre de l'Union Européenne ou partie à l'accord sur l'Espace Économique Européen",
    NUMERO_ET_LIEU: "Numéro et lieu d'immatriculation",
    PAS_IMMATRICULE:
        "n'est pas immatriculée ou relève de la législation d'un autre État membre de l'Union Européenne ou partie à l'accord sur l'Espace Économique Européen",
    ADRESSE_DU_DOMICILE_PERSONNEL: 'Adresse du domicile personnel',
    VIGILANCE_OWNER: 'Identification des bénéficiaires effectifs',
    VIGILANCE_OWNER_TABLE_PP:
        "Bénéficiaires effectifs - Personnes physiques (merci de télécharger une pièce d'identité valide)",
    VIGILANCE_OWNER_TABLE_PM: 'Bénéficiaires effectifs - Personnes morales',
    VIGILANCE_OWNER_EMPTY_FIELDS: 'Vous devez saisir tous les champs du tableau pour continuer.',
    DATE_DE_CLOTURE: "Date de clôture d'exercice fiscal",

    AUTO_CERTIFICATION: "Auto-certification de l'entité",
    PLEASE_CHOOSE_CATEGORY: 'Veuillez cocher la catégorie correspondante\xa0:',

    // ---- Subscriber Details ----
    PROFIL_INVESTISSEUR: 'Profil investisseur',
    VALIDATE_PRO_STATUS: 'Valider le statut',
    INVALIDATE_PRO_STATUS: 'Refuser le statut',
    DERNIERE_CONNEXION: 'Dernière connexion',
    DOCUMENTS: 'Documents',

    //ALERTS
    ALERTS: {
        ALERTS: 'Alertes',
        NO_ALERTS: 'Sans alertes',
        CRITICAL_ALERT: 'Alerte rouge',
        CRITICAL_ALERTS: 'Alertes rouges',
        WARNING_ALERT: 'Alerte orange',
        WARNING_ALERTS: 'Alertes oranges',
        ORANGE: 'orange',
        RED: 'rouge',
        GREEN: 'verte',
        ALERT_TEXT: "Texte de l'alerte",
        NO_ALERT_TEXT: "Sans texte de l'alerte",
        SOLVE_ALERT: "Enlever l'alerte",
        ALERT_CONDITION: "Condition de l'alerte",
        WRONG_CHARACTER: 'Caractère non approprié',
        LESS_THAN: 'est inférieur à',
        GREATER_THAN: 'est supérieur à',
        EQUAL: 'est égal à',
    },

    NO_SUBSCRIPTION_ALERTS: 'Aucune alerte pour cette souscription.',
    NO_SUBSCRIPTION_DOCUMENTS: 'Aucun document fourni pour cette souscription.',
    NO_DOCUMENTS: 'Aucun document fourni.',
    DOC_MUST_BE_PDF: 'Vous devez télécharger un fichier PDF.',
    AUCUN_REPORT: 'Les rapports de gestion seront bientôt disponibles',
    FAILED_DOCUMENT_DOWNLOAD: "Le document n'a pas pu être téléchargé",
    VALIDATED_BY: (name, date) => `Validé le ${date} par ${name}.`,
    INVALIDATED_BY: (name, date) => `Refusé par ${name} le ${date}.`,
    KBIS_DOC: 'K-Bis',
    AP_DOC: 'Autorisation de prélèvement',
    AP_DOC_DISABLED: 'Autorisation de prélèvement désactivée',
    BS_DOC: 'Bulletin de Souscription',
    POUVOIR_DOC: 'Pouvoir du représentant légal signé',
    FACTURE_DOC: 'Justificatif de domicile',
    STATUTES_DOC: 'Statuts à jour du souscripteur',
    AFFIDAVIT_DOC: "Attestation sur l'honneur",
    BLANCHIMENT_DOC: 'Formulaire de blanchiment',
    INVESTOR_VIGILANCE_DOC:
        "Document justificatif concernant la vigilance réduite pour l'investisseur",
    BENEFICIARY_VIGILANCE_DOC: 'Document justificatif concernant le statut du bénéficiaire',
    BENEFICIARY_DOC: 'Document justificatif concernant le bénéficiaire effectif',
    TAX_EXEMPTION_DOC: 'Attestation fiscale',
    INVESTOR_CLASSIFICATION_DOC: 'Attestation classification client',
    EXEMPTION_CONDITION_PROOF_DOC: 'Justificatif cas dérogatoire',
    ID_CARD: "Carte d'identité",
    CO_SUBSCRIBER_ID_CARD: "Document d'identité co-souscripteur",
    ID_CARD_TWO_SIDED: "Carte d'identité (recto et verso)",
    DRIVING_LICENSE: 'Permis de conduire',
    PASSPORT: 'Passeport',
    PASSPORT_WITH_SIGNATURE: 'Passeport (avec page signature)',
    CREDIT_CARD: 'Carte de crédit',
    FILE_TYPES_ALLOWED: 'Type de document (format pdf, jpg ou png)',
    // ----------------------------

    MON_COMPTE: 'Mon compte',
    MY_INFOS: 'Mes informations',
    SUBSCRIBER: 'Souscripteur',
    CO_SUBSCRIBER: 'Co-souscripteur',
    INFOS: 'Informations',
    YOUR_INFO_SAVED: 'Vos données ont été sauvegardées.',
    INFO_SAVED: 'Les données ont été enregistrées.',

    // ---- Activites -----
    ACTIVITE_AGRICOLE: 'Agricole',
    ACTIVITE_INDUSTRIELLE: 'Industrielle',
    ACTIVITE_COMMERCIALE: 'Commerciale',
    ACTIVITE_HOLDING: 'Holding',
    AUTRE: 'Autre',
    AUTRES: 'Autres',
    // --------------------

    OTHER_ACTIVITY: 'Autre activité choisie par le souscripteur.',
    OTHER_CORPORATE_FORM: 'Autre forme sociale choisie par le souscripteur.',

    PASSWORD_CHANGE: 'Changement du mot de passe',
    CURRENT_PASSWORD: 'Mot de passe actuel',
    CURRENT_PASSWORD_INCORRECT: "Le mot de passe actuel n'est pas correct.",

    FUND_MANAGEMENT: 'Gestion des fonds',
    UPCOMING_PRODUCTS: 'Actualités',
    CREATE_INVESTMENT_FUND: 'Créer un nouveau fonds',
    SIGN_CONVENTION: 'Signer une convention',
    AWAITING_SERVICER_SIGNATURE: 'En attente de signature par AIFM',
    REQUEST_UPCOMING_TITLE: 'Demande prise en compte',
    REQUEST_UPCOMING_CONTENT:
        "Votre demande a bien été prise en compte, l'équipe commerciale vous contactera dans les meilleurs délais.",
    UPCOMING_REQUEST_RECEIVED:
        'Votre demande à bien été prise en compte vous recevrez tous les documents prochainement.',
    NO_FILE_UPLOADED: 'Aucun fichier téléchargé',
    FUND_CALLS: 'Appels de fonds',
    DATE_MORE_THAN: 'La date saisie doit être supérieure à celle choisie.',
    FUND_NAME: 'Nom du fonds',
    FUND_TYPE: 'Type du fonds',
    TYPE: 'Type',
    FUND: 'Fonds',
    ENGAGEMENT: 'Engagement',
    CAPITAL_CALLED: 'Engagement appelé',
    CAPITAL_CALLED_TO_DATE: 'ENGAGEMENT APPELÉ À DATE',
    CAPITAL_DUE: 'Engagement résiduel',
    LAST_CALL_DATE: 'Date de valeur liquidative',
    DATE_CLOSING: 'Date de fin de commercialisation',
    ENGAGEMENT_DATE: "Date d'engagement",
    COMMERCIALISATION_DATE: 'Date de commercialisation',
    COMMISSION_CONTROL_DATE: 'Date de création',
    TUNNELS: 'Tunnels',
    TUNNEL_VERSIONS: 'Version tunnels',
    NEWEST_VERSION: 'Nouvelle version',
    CONSULT_ACTIVE_TUNNEL_VERSION: 'Consulter la version active',
    RESULTS_STEP_TITLE: 'Titre étape Résultat',
    RESULTS_STEP_SUBTITLE: 'Sous-titre étape Résultat',
    ADD_STEP: 'Ajouter une étape',
    TUNNEL_STEP_VISIBILITY_LABEL: 'Visible seulement pour le souscripteur et la SGP',
    TUNNEL_STEP_EDITABLE_LABEL: 'Non modifiable après la soumission',
    STEP_TITLE: "Nom de l'étape",
    STEP_SUBTITLE: 'Sous-titre étape',
    TUNNEL_STEPS: 'Étapes',
    DELETE_TUNNEL_STEP: "Supprimer l'étape",
    CONFIRM_DELETE_TUNNEL_STEP: "Etes-vous sûrs de vouloir supprimer l'étape\xa0?",
    DELETE_QUESTION: 'Supprimer la question',
    CONFIRM_DELETE_QUESTION: 'Etes-vous sûrs de vouloir supprimer la question\xa0?',
    DELETE_ANSWER: 'Supprimer la réponse',
    CONFIRM_DELETE_ANSWER: 'Etes-vous sûrs de vouloir supprimer la réponse\xa0?',
    ADD_QUESTION: 'Ajouter une question',
    QUESTION_TEXT: 'Texte de la question',
    ADD_ANSWER: 'Ajouter une réponse',
    ANSWER_TEXT: 'Texte de la réponse',
    ANSWER_SCORE: 'Valeur de la réponse',
    MANDATORY: 'Obligatoire',
    OPTIONAL: 'Facultative',
    QUESTION_COMPULSORINESS_LABEL: 'Caractère obligatoire',
    RADIO_BUTTONS: 'Boutons radio',
    CHECKBOXES: 'Cases-à-cocher',
    TEXT_FIELDS: 'Champs',
    QUESTIONNAIRE: 'Questionnaire',
    DELETE_TUNNEL_VERSION: 'Supprimer la version',
    CONFIRM_DELETE_TUNNEL_VERSION: 'Etes-vous sûrs de vouloir supprimer la version\xa0?',
    ACTIVATE_TUNNEL_VERSION: 'Activer la version',
    MANUALLY_CREATED_STEP: 'Manually Created Step',
    CHANGES_NOT_CONFIRMED: 'Changements non enregistrés',
    CONFIRM_DISCARD_CHANGES:
        'Vos derniers changements ne sont pas sauvegardés. Êtes-vous sûrs de vouloir continuer ?',
    ACTIONS: 'Actions',
    ADD_ACTION: 'Ajouter une action',
    ACTION_NAME: "Nom de l'action",
    QUESTIONS: 'Questions',
    MIN_SCORE: 'Score minimum',
    MAX_SCORE: 'Score maximum',
    IF_SUSCRIBER_SCORE: 'Si le scoring souscripteur',
    ADD_CONDITION: 'Ajouter une condition',

    ACTION_QUESTIONS_REQUIRED: 'Vous devez ajouter au moins une question pour continuer',
    ACTION_CONDITIONS_REQUIRED: 'Vous devez ajouter au moins une condition pour continuer',
    DELETE_ACTION: "Supprimer l'action",
    CONFIRM_DELETE_ACTION: "Etes-vous sûrs de vouloir supprimer l'action ?",

    CLOSINGS: 'Closings',
    PREMIUM_LABEL: 'Avec ou sans prime',
    WITHOUT_PREMIUM: 'Sans prime',
    WITH_PREMIUM: 'Avec prime',
    CLOSING_NBUMBER: 'Numéro du closing',
    CLOSING_DATE: 'Date closing',
    CLOSING_HISTORY: 'Historique des closings',
    CLOSING_ACTIVATION: 'Activation du closing',
    CONFIRM_CLOSING_ACTIVATION: 'Etes-vous sûrs de vouloir activer le closing\xa0?',

    ADDRESS: 'Adresse',
    FISCAL_ADDRESS_BUTTON: 'Adresse fiscale si différente',
    MANUAL_ADDRESS: 'Saisie non assistée',
    USE_MANUAL_ADDRESS_FORM: "Cliquez ici pour saisir l'adresse manuellement.",
    REGIME_MATRIMONIAL: 'Régime matrimonial',
    LEGAL_COMMUNITY: 'Communauté légale',
    PARTICIPATION_ACQUISITIONS: 'Participation aux acquêts',
    UNIVERSAL_COMMUNITY: 'Communauté universelle',
    PROPERTY_SEPARATION: 'Séparation de biens',

    AGROALIMENTAIRE: 'Agroalimentaire',
    ASSOCIATIONS: 'Associations',
    BANKS: 'Banques',
    INSURANCE: 'Assurances',
    FINANCIAL_SERVICES: 'Services financiers',
    CHEMISTRY: 'Chimie',
    TRADE: 'Commerce',
    COMMUNICATION: 'Communication',
    CONSTRUCTION: 'Construction',
    CULTURE: 'Culture',
    ENERGY: 'Energie',
    EDUCATION: 'Enseignement',
    ENVIRONMENT: 'Environnement',
    GESTION: 'Gestion',
    BUSINESS_MANAGEMENT: ' Administration des entreprises',
    REAL_ESTATE: 'Immobilier',
    INDUSTRY: 'Industrie',
    INFORMATICS: 'Informatique',
    LOGISTICS: 'Logistique',
    TRANSPORTATION: 'Transports',
    LIBERAL_PROFESSIONS: 'Professions libérales',
    HEALTH: 'Santé',
    SERVICES: 'Services',

    ACTIVITY_SECTOR: "Secteur d'activité",
    RESIDENT_FISCAL_USA: "Avez-vous été résident(e) fiscal(e) des États Unis d'Amérique\xa0?",
    ASK_TIN_NUMBER:
        "Pourriez-vous indiquer votre numéro d'immatriculation fiscal des États-Unis d'Amérique (TIN)\xa0?",
    NIF_ABSENCE_REASON: "Motif en cas d'absence de NIF",
    CO_SUBSCRIBER_NIF_ABSENCE_REASON: "Motif en cas d'absence de NIF pour le co-souscripteur",
    FISCAL_OBLIGATION_OTHER_COUNTRY:
        'Êtes-vous soumis à des obligations fiscales dans un autre pays\xa0?',
    FISCAL_OBLIGATION_QUESTION:
        'Si oui, veuillez nous communiquer le nom du (ou des) pays et le numéro fiscal correspondant (si le pays en communique un).',
    ASK_IF_POLITICALLY_EXPOSED: 'Êtes-vous une personne politiquement exposée\xa0?',

    PROVENANCE_DES_FONDS: `Provenance des fonds`,
    ORIGINE_DES_FONDS: `Origine des fonds`,

    VALEUR_MOBILIERE: 'Vente de valeur mobilière',
    VALEUR_IMMOBILIERE: ' Vente immobilière',
    VALEUR_LIQUIDITE: 'Liquidité disponible',

    FRANCE: 'France',
    UE: 'Union Européenne (hors France)',
    NON_UE: 'Hors Union Européenne',
    CHOCHER_CASE: `Veuillez cocher la case pour continuer`,

    FOREIGN_COUNTRY_NIF_EMPTY:
        "Le souscripteur a des obligations fiscales dans un autre pays, mais il n'a pas saisi le NIF.",
    FOREIGN_COUNTRY_CO_SUBSCRIBER_NIF_EMPTY:
        "Le co-souscripteur a des obligations fiscales dans un autre pays, mais il n'a pas saisi le NIF.",
    TIN_EMPTY: "Le TIN n'a pas été saisi par le souscripteur.",
    TIN_EMPTY_CO_SUBSCRIBER: "Le TIN n'a pas été saisi par le co-souscripteur.",
    TIN_INVALID: 'Le TIN doit contenir 13 chiffres.',
    US_TAX_RESIDENCY: "Le souscripteur a été résident(e) fiscal(e) des États Unis d'Amérique.",
    US_TAX_RESIDENCY_CO_SUBSCRIBER:
        "Le co-souscripteur a été résident(e) fiscal(e) des États Unis d'Amérique.",
    WITH_CO_SUBSCRIBER: 'Co-souscription',

    DOMICILIE_EN_FRANCE:
        "Est-ce que votre compte est domicilié dans l'Union Européenne, l'Espace Economique Européen ou pays tiers équivalent\xa0?",
    MODE_REGLEMENT: 'Merci de choisir le mode de règlement',
    FOURNIR_LE_RIB: 'Merci de nous fournir le RIB (ou IBAN)',
    PROVIDE_NEW_RIB: 'Merci de nous fournir le nouveau RIB',
    SUBMIT_ENTRUSTED_RIB:
        'Merci de nous founir le RIB du compte titres afin de livrer la position chez votre teneur de compte.',

    RIB_NOT_FRENCH: "Le RIB du souscripteur n'est pas français.",
    RIB_IBAN_NOT_MATCHING: "L'IBAN saisi et l'IBAN retourné par Jumio ne sont pas identiques.",
    RIB_BIC_NOT_MATCHING: ({ bicVerified, bicInput }) =>
        `Attention : BIC rentré par le souscripteur ${bicInput}; BIC envoyé par Viamobis ${bicVerified} sont différents.`,
    NOM_EXTRAIT: 'Le nom extrait du RIB ne correspond pas à la saisie du souscripteur.',
    RIB_ECHOUE: 'La vérification du RIB a échoué.',
    RIB_REPLACEMENT: 'Remplacement du RIB',

    REMPLACER: 'Remplacer',
    REPLACED_ON_BY: (onDate, byUser) => `Remplacé le ${onDate} par ${byUser}`,
    REPLACE_AND_ARCHIVE: 'Remplacer et archiver',

    COMMENTAIRES: 'Commentaires',
    LAISSER_UN_COMMENTAIRE: 'Merci de laisser un commentaire afin de pouvoir sauvegarder.',
    MAX_CHARACTER_ERROR: 'Vous avez dépassé la limite des caractères.',

    ADRESSE_100M: 'Adresse existante dans un rayon de plus de 100 mètres',

    MIEUX_VOUS_CONNAITRE: 'Mieux vous connaître',
    DISTRIBUTOR_DOCUMENTS_TITLE: 'Merci de nous fournir les documents nécessaires',
    DISTRIBUTOR_DOCUMENTS_SUBTITLE:
        "Si vous n'êtes pas en possession de l'ensemble des documents, vous pouvez remplir partiellement ce formulaire, et sortir du processus d'inscription en cliquant sur le bouton DÉCONNEXION. Les documents téléchargés sont conservés. Il vous suffira de vous reconnecter avec vos identifiants pour compléter le formulaire.",
    ORIAS_ATTESTATION: 'Attestation ORIAS',
    ACPR_NUMBER: "Numéro d'agrément ACPR",
    CRIMINAL_RECORD_EXTRACT:
        'Extrait du casier judiciaire du représentant légal (de moins de 3 mois)',
    KBIS_RECENT: 'Kbis de la société de moins de 3 mois',
    KBIS_SIMPLIFIED: 'Kbis de moins de 3 mois',
    INSURANCE_CERTIFICATE: "Attestation d'assurance",
    LEGAL_REPRESENTANT_ID: "Pièce d'identité du représentant légal",
    SIGNATORY_ID: "Pièce d'identité du signataire",
    ALLOWED_DOCUMENTS: 'Les pièces admises sont\xa0:',
    ALLOWED_DOCUMENTS_PASSPORT: 'Passeport, incluant la page de signature',
    ALLOWED_DOCUMENTS_ID: "Carte d'identité (recto et verso)",
    ALLOWED_DOCUMENTS_DRIVER_LICENCE: 'Permis de conduire européen (recto et verso)',
    RIB: "Relevé d'identité bancaire",
    RIB_SOCIETE: "Relevé d'identité bancaire de la société",
    COMPANY_LOGO: 'Logo de la société',
    LOGO_OPTIONAL: 'Logo de votre société (fortement recommandé)',
    LOGO_ACCEPTED_FORMAT: 'Format accepté : image. Taille maximale admise : 10MB.',
    LOGO: 'Logo',

    AJOUTER_UN_DOCUMENT: 'Ajouter un document',
    CONFIDENTIAL: 'Confidentiel',
    CONFIDENTIAL_DOCUMENTS: 'Documents confidentiels',

    LAST_STEP_ONBOARDING: 'Merci de votre confiance',
    LES_ELEMENTS_AURONT:
        "Dès que les documents fournis auront été revus et validés par la société de gestion, vous recevrez un e-mail de confirmation qui vous permettra d'accéder à votre espace partenaire.",
    DISTRIBUTEUR_LIST_TITLE: 'Distributeurs',
    DISTRIBUTOR_FAST_CREATE: 'Création rapide de distributeur',
    EDIT_DISTRIBUTOR: companyName => `Modifier le distributeur ${companyName}`,
    QUARTER_STATEMENT: 'Relevé trimestriel',
    QUARTER_STATEMENT_ACTIVATION: 'Activation des relevés trimestriels',
    CONFIRM_QUARTER_STATEMENT_ACTIVATION:
        'Etes-vous sûrs de vouloir activer les relevés trimestriels\xa0?',
    STATUT: 'Statut',
    COMPANY_NAME: 'Dénomination société',
    DISTRIBUTOR_TYPE: 'Type de distributeur',
    SEES_COMMISSIONS_MENU: 'Voit le menu des commissions',
    GETS_QUARTER_STATEMENTS: 'Reçoit les emails trimestriels de rémunération',

    LEGAL_REPRESENTANT_AUTHORITY_ALT: 'Pouvoir signé',
    CRIMINAL_RECORD_EXTRACT_ALT: 'Extrait judiciaire',
    BENEFICIARIES_REGISTER: 'Registre des Bénéficiaires Effectifs',
    LEGAL_REPRESENTATIVES_IDS: "Pièces d'identité des représentants légaux",
    BENEFICIARIES_IDS: "Pièces d'identité des Bénéficiaires Effectifs",
    KBIS_RECENT_ALT: 'Kbis de la société',
    LEGAL_REPRESENTANT_ID_ALT: "Document d'identité du représentant legal",
    SIGNATORY_ID_ALT: "Document d'identité du signataire",

    MY_DOCUMENTS: 'Mes documents',
    YOUR_INVESTOR_PROFILE_DOCUMENTS: 'DOCUMENTS LIÉS À VOTRE PROFIL INVESTISSEUR',
    INVESTOR_PROFILE_DOCUMENTS: 'Documents liés au profil investisseur',
    OLD_DOCUMENTS: 'Anciens Documents',
    INVESTMENT_RELATED_DOCUMENTS: 'DOCUMENTS DE SOUSCRIPTION',
    FUND_LIFE: 'VIE DU FONDS',
    FUNDS_LIFE: 'Vie des Fonds',
    VALIDATE_CHANGE: 'Valider la mise à jour',
    INVALIDATE_CHANGE: 'Refuser la mise à jour',

    MY_MESSAGES: 'Mes messages',
    MESSAGES: 'Messages',
    NO_MESSAGE: 'Aucun message',

    DOCUMENT_NAME: 'Nom du document',
    DATE_PICKER_INFO: "Vous pouvez cliquer sur l'année pour accéder aux années précédentes.",
    INVALID_NIF_MESSAGE: "Le numéro d'identification fiscale doit contenir 13 chiffres.",
    INVALID_IBAN_MESSAGE: "L'IBAN saisi n'est pas valide.",
    EMPTY_BIC_MESSAGE: 'Vous devez saisir ce champ pour continuer',
    ADDRESS_INFO_BUTTON:
        "Un justificatif de domicile vous sera demandé afin de valider l'adresse que vous renseignez dans ce champs.",
    ID_DOCUMENT_VERIFICATION_TITLE: "Vérification du document d'identité",
    ID_DOCUMENT_VERIFICATION_TEXT_1: "La carte de résident peut remplacer la carte d'identité.",
    ID_DOCUMENT_VERIFICATION_TEXT_2:
        'Seuls les permis de conduire au format européen sont acceptés.',

    USERS: 'Utilisateurs',
    CREATE_USER: 'Créer utilisateur',
    CREATE_SUBSCRIPTION: 'Créer une souscription',
    EXTERNAL_SUBSCRIPTION_INTEGRATION: 'Intégrer souscription externe',
    EMAIL_UNAVAILABLE:
        "Ce n'est pas possible de créer une souscription sur cette adresse. Merci de contacter l'équipe Peqan.",
    CATEGORY_UNAVAILABLE: 'Le distributeur ne peut pas commercialiser la catégorie choisie',
    IMPORT: 'Importer',
    IMPORT_SUCCESSFUL:
        "L'import est lancé. Un email sera envoyé à contact@petech.fr avec le résultat. Merci de patienter.",
    IMPORT_USER_LIST: "Importer une liste d'utilisateurs",
    NORMAL: 'Normale',
    CLEAN_SHARE: 'Clean-share',
    RESERVED: 'Reservée',
    ADMIN: 'Administrateur',
    COMMERCIAL: 'Commercial',
    NETWORK_ADMIN: 'Animateur et support de réseau',
    DISTRIBUTOR_MAIN_USER: 'Signataire',
    EDIT: 'Modifier',
    SIMULATE: 'Simuler',
    ACTIVATE: 'Activer',
    TEST: 'Tester',
    TRACE: 'Tracer',

    SIGN_BS: 'SIGNER LE BS',
    TRANSFER: 'Transférer',
    TRANSFER_SUBSCRIPTION: 'Transférer la souscription',
    TRANSFER_TO_SUBSCRIBER: 'Envoyer au souscripteur',
    TRANSFER_TO_SUBSCRIBER_INFO:
        "Dans le cadre de la convention signée avec la société de gestion, les droits d'entrée pour une souscription sont négociables dans la limite du maximum défini dans le règlement du fonds.",
    WRONG_ADMISSION_FEE: "La valeur saisie dépasse les droits d'entrées maximum pour ce produit.",

    FCPR_PEDAGOGIC_STEP_TITLE: 'Bienvenue dans le processus de souscription en ligne du fonds',
    FCPR_PEDAGOGIC_STEP_PARAGRAPH_1:
        "Merci de l'intérêt que vous portez à nos solutions d'investissement.",
    FCPR_PEDAGOGIC_STEP_PARAGRAPH_2:
        "Afin de bénéficier d'une expérience de souscription digitale optimisée, nous vous invitons à préparer les documents suivants\xa0:",
    FCPR_PEDAGOGIC_STEP_PARAGRAPH_3:
        'Le processus de souscription prendra une quinzaine de minutes et se terminera par la signature électronique du bulletin de souscription.',
    FCPR_PEDAGOGIC_STEP_PARAGRAPH_4:
        "Dans le cadre de la signature électronique, vous recevrez un code par SMS afin d'authentifier votre signature.",
    FCPR_PEDAGOGIC_STEP_PARAGRAPH_5:
        "Un email de confirmation de votre souscription sera envoyé sur l'adresse mail renseignée lors de la création de votre compte.",
    FCPR: '(Fonds Commun de Placement à Risque)',
    KYC_PEDAGOGIC_STEP: 'Quelques questions pour mieux vous connaître',
    KYC_PEDAGOGIC_STEP_1: 'Quelques questions',
    KYC_PEDAGOGIC_STEP_2: 'pour mieux vous connaître',
    KYC_PEDAGOGIC_STEP_SLP:
        "L'objectif des questionnaires suivants est de permettre à la société de gestion d'évaluer le caractère approprié de votre investissement au regard de vos connaissances et de votre expérience en matière d'investissement. Vous serez informé si, sur la base de l'évaluation du caractère approprié, le fonds d'investissement est considéré comme inapproprié pour vous.",
    KYC_PEDAGOGIC_STEP_PARAGRAPH_1:
        "L'objectif des questionnaires suivants est de déterminer votre connaissance des marchés financiers et votre capacité financière pour faire face aux risques liés à l'investissement dans le fonds.",
    KYC_PEDAGOGIC_STEP_PARAGRAPH_2: (fundType, fundName) =>
        `A noter que les réponses doivent être complètes et précises, afin que la société de gestion puisse s'assurer du caractère approprié de votre souscription ${
            fundType === 'SLP' ? 'à la' : 'au'
        } ${fundType} ${fundName}.`,
    KYC_PEDAGOGIC_STEP_PARAGRAPH_3:
        "Ces informations devront être actualisées en fonction de l'évolution de votre situation (ou autres circonstances personnelles) et feront l'objet d'une revue régulière.",

    ELIGIBILITY: 'Eligibilité',
    INVESTMENT: 'Investissement',
    PROFESSIONAL_FUND: 'Fonds professionnel',
    PRO_FUND_RESERVED:
        'Le fonds est réservé à des investisseurs professionels par nature ou professionels par option.',
    POUVOIR_SOUSCRIERE_PP: sgp =>
        `Pour pouvoir souscrire en tant que personne physique à un FPCI (Fonds Professionnel de Capital Investissement) géré par ${sgp}, vous devez\xa0:`,
    POUVOIR_SOUSCRIERE_PM: sgp =>
        `Pour pouvoir souscrire en tant que personne morale à un FPCI (Fonds Professionnel de Capital Investissement) géré par ${sgp}, veuillez choisir la typologie de votre entreprise\xa0:`,
    POUVOIR_SOUSCRIERE_FPS_PP: sgp =>
        `Pour pouvoir souscrire en tant que personne physique à un FPS (Fonds Professionnel Spécialisé) géré par ${sgp}, vous devez\xa0:`,
    POUVOIR_SOUSCRIERE_FPS_PM: sgp =>
        `Pour pouvoir souscrire en tant que personne morale à un FPS (Fonds Professionnel Spécialisé) géré par ${sgp}, veuillez choisir la typologie de votre entreprise\xa0:`,
    POUVOIR_SOUSCRIERE_SLP_PP: sgp =>
        `Pour pouvoir souscrire en tant que personne physique à une SLP (Société de Libre Partenariat) gérée par ${sgp}, vous devez\xa0:`,
    POUVOIR_SOUSCRIERE_SLP_PM: sgp =>
        `Pour pouvoir souscrire en tant que personne morale à une SLP (Société de Libre Partenariat) gérée par ${sgp}, veuillez choisir la typologie de votre entreprise\xa0:`,
    MONTANT_DE_ENVISAGE: "Montant de l'investissement envisagé (en EUR)",
    VOTRE_INTERVANTION:
        'Pourriez-vous nous préciser le cadre de votre intervention pour valider votre demande de souscription\xa0?',
    INDIQUER_LE_NOM: sgp =>
        `Pourriez-vous nous indiquer le nom d'une personne de l'équipe de ${sgp} susceptible de confirmer votre intervention à nos côtés\xa0?`,
    SEIN_DE_LAQUELL:
        "Pourriez-vous préciser l'entité au sein de laquelle vous avez eu une expérience d'investisseur ou le ou les FIA dans lesquels vous avez souscrit\xa0?",
    NOM_DE_ENTITE: "Nom de l'entité",
    NOM_DU_FIA: 'Nom du FIA',
    DUREE_DE_DETENTION: 'Durée de détention',
    CHOSING_SUBCATEGORY: 'Choisir la catégorie de parts',

    USER_KNOWLEDGE: 'Connaissances et compétences',
    USER_KNOWLEDGE_SUBTITILE:
        "L'objectif de ce questionnaire est de s'assurer que vous disposez de suffisamment de connaissances et d'expérience dans le domaine des affaires, de la fiscalité, de la finance et du capital-investissement pour comprendre les risques et autres considérations afférentes à une souscription aux parts du fonds.",
    USER_KNOWLEDGE_SUBTITILE_SLP:
        "L'objectif de ce questionnaire est de s'assurer que vous disposez de suffisamment de connaissances et d'expérience dans le domaine des affaires, de la fiscalité, de la finance et du capital-investissement pour comprendre les risques et autres considérations afférentes à une souscription dans une SLP.",
    USER_KNOWLEDGE_DISCLAIMER:
        "A noter que lorsqu'une personne morale est représentée par une autre personne morale ou personne physique en capacité d'engager la responsabilité de la personne morale, les connaissances et l'expérience sont celles du représentant de la personne morale ou de la personne autorisée à effectuer les transactions au nom de la personne morale.",
    USER_KNOWLEDGE_MEDIA_CONSULTATION:
        'Connaissance des produits financiers - consultation des médias financiers ou économiques.',
    USER_KNOWLEDGE_LEVEL_WARNING: (level_1, level_2) =>
        `Niveau de connaissances et compétences: Score ${level_1} / ${level_2}.`,
    USER_KNOWLEDGE_WEAK_SCORES:
        "Niveau faible de connaissances et d'expérience dans le domaine des affaires, de la fiscalité, de la finance et du capital-investissement",
    USER_KNOWLEDGE_SLP_LEVEL1_SCORE: (level_1, rating) =>
        `Compréhension du produit : ${rating}, score ${level_1}/45`,
    USER_KNOWLEDGE_SLP_LEVEL2_SCORE: (level_2, rating) =>
        `Connaissance des instruments financiers : ${rating}, score ${level_2}/20`,
    USER_KNOWLEDGE_ORIGIN: answer => `Réponse aux questions déclaratives : ${answer}`,

    YOUR_INVESTOR_PROFILE: 'Votre profil investisseur',
    COMPTE_TENU: promoterName =>
        `Compte tenu des réponses fournies, ${promoterName} considère que vous disposez de l'expérience, des connaissances et des compétences pour souscrire au fonds professionnel de capital investissement (FPCI).`,
    COMPTE_TENU_FPS: promoterName =>
        `Compte tenu des réponses fournies, ${promoterName} considère que vous disposez de l'expérience, des connaissances et des compétences pour souscrire au fonds professionnel spécialisé (FPS).`,
    COMPTE_TENU_SLP: promoterName =>
        `Compte tenu des réponses fournies, ${promoterName} considère que vous disposez de l'expérience, des connaissances et des compétences pour souscrire à une Société de Libre Partenariat (SLP).`,
    OBJECTIV: fundName =>
        `Pour déterminer si votre objectif d'investissement et votre profil sont adaptés à celui du Fonds ${fundName}, nous devons nous assurer que vous avez une bonne appréciation des risques inhérents à ce type d'investissement et que ce placement correspond à vos attentes.`,
    OBJECTIV_SLP: fundName =>
        `Pour déterminer si votre objectif d'investissement et votre profil sont adaptés à celui de la SLP ${fundName}, nous devons nous assurer que vous avez une bonne appréciation des risques inhérents à ce type d'investissement et que ce placement correspond à vos attentes.`,
    OBJECTIV_2:
        "De plus, nous devons nous assurer que vous disposez de la capacité financière à supporter le risque économique d'une souscription aux parts du fonds et de moyens suffisants pour subvenir à vos besoins actuels et futurs et à de possibles imprévus.",
    NOT_ADEQUATE_P1: fundName =>
        `Compte tenu de vos réponses, nous avons des doutes sur l'adéquation du produit ${fundName} avec votre profil.`,
    NOT_ADEQUATE_P2:
        "Vous pouvez si vous le souhaitez modifier vos réponses ou demander à être contacté par l'un de nos conseillers financiers.",
    SENSIBILITE_AU_RISQUE: 'Sensibilité au risque',
    COMPREHENSION_DU_PRODUIT: 'Compréhension du produit',
    VOS_ATTENTES: 'Vos attentes',
    VOICI_AFFIRMATIONS:
        'Voici quelques affirmations, veuillez cocher celle qui vous convient le mieux\xa0:',

    EXPERIENCE: 'Expérience',
    KNOWLEDGE_AND_EXPERIENCE: 'Connaissances et expérience',
    EXPERIENCE_SUBTITLE:
        "L'objectif de ce questionnaire est de mesurer votre expérience sur les marchés financiers et en private equity.",
    EXPERIENCE_SUBTITLE_FCPR:
        "L'objectif de ce questionnaire est comprendre vos connaissances et de mesurer votre expérience sur les marchés financiers et en private equity.",
    FINANCIAL_INSRUMENT_SCORE_ALERT:
        'Client peu averti sur le non cotés mais expérience sur les marchés existantes',
    FINANCIAL_INSRUMENT_SCORE_OTHER: 'Instrument financier détenu : Autre',

    KYC_SURVEY_FPCI_SUBTITLE:
        "L'investissement dans le Fonds comporte des risques et nous devons nous assurer que vous disposez d'une capacité financière suffisante pour faire face aux risques liés à l'investissement dans le fonds.",
    KYC_SURVEY_SLP_SUBTITLE:
        "L'investissement dans la SLP comporte des risques et nous devons nous assurer que vous disposez d'une capacité financière suffisante pour faire face aux risques liés à l'investissement dans la SLP.",
    CONFIRM_INELLIGIBLE:
        'Je vous confirme ma compréhension de ce point et souhaite continuer ma souscription',
    PROFIL_INVESTISSEUR_INCORRECT:
        'Votre profil investisseur ne semble pas être en adéquation avec le profil rendement risque du produit.',
    MOVABLE_INCOME: 'Source principale des revenus - Revenus mobiliers',
    REAL_ESTATE_INCOME: 'Source principale des revenus - Revenus immobiliers',
    HERITAGE_GREATER_15_PERCENT: isRolePP =>
        `Le montant de la souscription > 15% ${isRolePP ? 'du patrimoine global' : 'des actifs'}.`,
    INDEBTEDNESS_HERITAGE_RATIO: isRolePP =>
        `Le rapport ${isRolePP ? 'endettement/patrimoine' : 'passif/actif'} > 1.25`,
    OTHER_EXPENSES: amount =>
        `Le souscripteur a d'autres charges, le montant annualisé est de ${amount} euros`,

    AFIN_DE_MIEUX:
        'Après validation de ce formulaire, vous recevrez un code sur le numéro de téléphone renseigné',

    SURVEY_RESULTS: 'Résultats des questionnaires',
    PRO_CHECK_CONTENT:
        'Le fonds est réservé à des investisseurs professionels par nature ou professionels par option.',
    SURVEY_RESULTS_SUB_LINE_1: "Vous avez indiqué agir en tant qu'investisseur ",
    SURVEY_RESULTS_SUB_LINE_2: fundName =>
        `Compte tenu de vos réponses aux questionnaires, la société de gestion vous a classifié comme investisseur averti et a le plaisir de vous informer que vous êtes éligible à la souscription dans le fonds ${fundName}.`,
    SURVEY_RESULTS_SLP_LINE_2: fundName =>
        `La  société de gestion vous a classifié comme investisseur averti et a le plaisir de vous informer que vous êtes éligible à la souscription dans la SLP ${fundName}.`,
    SURVEY_RESULTS_SLP_ALERT_DISCLAIMER:
        "L'évaluation des informations fournies par vos soins indique que la transaction envisagée n'est pas appropriée et que vous ne disposez pas de l'expérience et de la connaissance nécessaires pour souscrire à ce produit. Vous pouvez néanmoins, si vous le souhaitez, poursuivre votre souscription tout en reconnaissant avoir été informé des facteurs de risques liés à cette souscription.",
    SURVEY_RESULTS_SUB_LINE_3:
        'Si vous le souhaitez, vous pouvez être considéré comme un investisseur professionnel sur option si vous justifiez de 2 des 3 conditions suivantes :',
    SURVEY_RESULTS_SUB_LINE_3_COND_1:
        'Avoir réalisé au moins 10 transactions (>600 € chacune) par trimestre au cours des 4 derniers trimestres',
    SURVEY_RESULTS_SUB_LINE_3_COND_2:
        "Disposer d'un portefeuille d'instruments financiers de plus de 500 000 €",
    SURVEY_RESULTS_SUB_LINE_3_COND_3:
        'Occuper ou avoir occupé, depuis au moins un an, une position professionnelle requérant une connaissance des transactions ou des services envisagés.',
    SURVEY_RESULTS_PROFESSIONAL_CLIENT:
        'Je souhaite être considéré comme client professionnel sur option',
    SURVEY_RESULTS_SELECT_HEADER:
        "A noter qu'en vous déclarant comme client professionnel sur option, vous déclarez posséder une expérience et des connaissances équivalentes à celles d'un professionnel et renoncez à une partie des protections apportées par la réglementation ainsi que les droits à indemnisations. ",
    SURVEY_RESULTS_SELECT_OPTIONS:
        "Afin d'opter pour le statuts de client professionnel sur option, vous devez respecter deux des trois critères suivants: ",
    SURVEY_RESULTS_INFO_BUTTON_TITLE: 'Client professionnel sur option',
    SURVEY_RESULTS_INFO_BUTTON_CONTENT_FPCR:
        "A noter qu'en vous déclarant comme client professionnel sur option, vous déclarez posséder une expérience et des connaissances équivalentes à celles d'un professionnel et renoncez à une partie des protections apportées par la réglementation ainsi que les droits à indemnisations. Le détail de ses droits est disponible sur demande auprès de la société de gestion.",
    SURVEY_RESULTS_INFO_BUTTON_CONTENT: promoterName =>
        `${promoterName} procédera à l'analyse de la demande du client et se réserve le droit de refuser la classification en client professionnel si les conditions ne sont pas réunies.`,
    SURVEY_RESULTS_HAS_TRANSACTIONS:
        'Avez-vous déjà réalisé au moins 10 transactions (supérieures à 600 € chacune) par trimestre au cours des 4 derniers trimestres\xa0?',
    SURVEY_RESULTS_PORTFOLIO_VALUE:
        "La valeur de votre portefeuille d'instruments financiers dépasse-t-elle 500\xa0000\xa0€\xa0?",
    SURVEY_RESULTS_PROFESSIONAL_POSITION_HELD:
        'Occupez-vous depuis au moins un an ou avez-vous occupé pendant au moins un an, dans le secteur financier, une position professionnelle requérant une connaissance des transactions ou des services envisagés\xa0?',
    SURVEY_RESULTS_HAS_TRANSACTIONS_DOCS:
        "Joindre un ou plusieurs documents justificatifs (ex: Relevé d'opérations…)",
    SURVEY_RESULTS_PORTFOLIO_VALUE_DOCS:
        'Joindre un ou plusieurs documents justificatifs (ex: Relevé de compte, reporting…)',
    SURVEY_RESULTS_PROFESSIONAL_POSITION_HELD_DOCS:
        'Joindre un ou plusieurs documents justificatifs (ex: Contrat, fiche de paie…)',
    OPTIONAL_DOCS_EXPLANATION:
        '* Documents facultatifs à ce stade. Des documents pourront être demandés par la société de gestion.',
    SURVEY_RESULTS_SUBMIT_CONDITION:
        'Vous devez avoir répondu Oui à au moins 2 questions et chargé les documents justificatifs correspondants.',
    SURVEY_RESULTS_WARNING_TRANSACTION_COMPLETED_NO_DOC:
        'Le souscripteur a déjà réalisé au moins 10 transactions (supérieures à 600 € chacune) par trimestre au cours des 4 derniers trimestres, mais aucun document fourni.',
    SURVEY_RESULTS_WARNING_PORTFOLIO_VALUE_NO_DOC:
        "La valeur du portefeuille d'instruments financiers dépasse 500 000 €, mais aucun document fourni.",
    SURVEY_RESULTS_WARNING_PROFESSIONAL_POSITION_NO_DOC:
        'Le souscripteur occupe depuis au moins un an ou a occupé pendant au moins un an, dans le secteur financier, une position professionnelle requérant une connaissance des transactions ou des services envisagés, mais aucun document fourni.',

    DOCUMENTS_REGLEMENTAIRES: 'Documents réglementaires',
    DOCUMENTS_REGLEMENTAIRES_FPS: 'Documents réglementaires',
    ALLOW_TO_SUBSCRIBE_COMMENT:
        "Afin de vous permettre de souscrire à notre produit en disposant d'une information complète, nous mettons à votre disposition le règlement et le document d'informations clés pour l'investisseur (DIC Priips).",
    ALLOW_TO_SUBSCRIBE_COMMENT_SLP:
        "Afin de vous permettre de souscrire à notre produit en disposant d'une information complète, nous mettons à votre disposition les statuts de la SLP et le document d'informations clés pour l'investisseur (DIC Priips).",
    ALLOW_TO_SUBSCRIBE_COMMENT_FPS:
        "Afin de vous permettre de souscrire à notre produit en disposant d'une information complète, nous mettons à votre disposition le Prospectus, le Règlement et le document d'informations clés pour l'investisseur (DIC Priips).",
    DOCUMENT_INFORMATION_CLE: "Document d'informations clés",
    CONTINUER_PLUS_TARD: 'Continuer plus tard',
    POUVEZ_REVENIR:
        'A noter que vous pouvez revenir à tout moment pour réaliser votre souscription.',
    VOUS_RECONNECTER:
        "Nous vous invitons à vous reconnecter avec l'adresse mail validée et le mot de passe fourni lors de votre souscription.",

    PERFORMANCE: "Découvrez l'univers du Private Equity Institutionnel",
    PROCESSUS_DE_SOUSCRIPTION: (fundName, sgp) =>
        `Bienvenue dans le processus de souscription en ligne du Fonds ${fundName} géré par ${sgp}.`,
    PROCESSUS_DE_SOUSCRIPTION_SLP: (fundName, sgp) =>
        `Bienvenue dans le processus de souscription en ligne de la SLP ${fundName} gérée par ${sgp}.`,
    PORTEZ_A_NOTRE: sgp => `Merci de l'intérêt que vous portez à notre produit ${sgp}.`,
    AFIN_DE_BENEFICIER:
        "Afin de bénéficier d'une expérience de souscription digitale optimisée, nous vous invitons à préparer les documents suivants\xa0:",
    DEUX_JUSTIFICATIFS:
        "Un justificatif d'identité (Carte d'identité / Passeport / Permis de conduire biométrique)",
    JUSTIFICATIF_DE_DOMICILE_DE_MOINS: 'Justificatif de domicile de moins de 3 mois',
    JUSTIFICATIF_DE_DOMICILE_REPRESENTANT_LEGAL: 'Un justificatif de domicile de moins de trois mois du représentant légal',
    VOS_COORDONNEES_BANCAIRES: 'Vos coordonnées bancaires (RIB)',
    NIF_REQUIRED:
        "Nous vous demanderons également votre NIF (Numéro d'identification fiscale) français ou équivalent étranger.",
    SOUSCRIPTION_PRENDRA:
        'Le processus de souscription prendra une dizaine de minutes et se terminera par la signature électronique du bulletin de souscription.',
    SOUSCRIPTION_PRENDRA_PM:
        'Le processus de souscription prendra une quinzaine de minutes et se terminera par la signature numérique du bulletin de souscription.',
    SIGNATURE_ELECTRONIQUE:
        "Dans le cadre de la signature électronique, vous recevrez un code par SMS afin d'authentifier votre signature.",
    SIGNATURE_NUMERIQUE:
        "Dans le cadre de la signature numérique, vous recevrez un code par SMS afin d'authentifier votre signature.",
    CONFIRMATION_DE_VOTRE_SOUSCRIPTION:
        "Un email de confirmation de votre souscription sera envoyé sur l'adresse mail renseignée lors de la création de votre compte.",

    RECONNAIS_AVOIR:
        "Je reconnais avoir été informé que le FCPR pourrait avoir recours à des opérations de portage auprès d'un tiers (lié ou non lié) dès lors que le fonds n'a pas terminé sa période de souscription.",

    ELIGIBILITY_CONTACT_SGP_INFO:
        'Compte tenu de votre réponse, veuillez contacter la SGP en envoyant un mail à ',
    CONTINUE_INSCRIPTION: 'Poursuivre votre souscription',

    ORGANISME_DE_PLACEMENT: 'Organisme de Placement Collectif en Valeur Mobilière',
    PRODUIT_FINANCIER_AYANT:
        "Produit financier ayant vocation à collecter de l'épargne et à investir dans des instruments financiers (actions, obligations, titres de créances, ...) selon une politique d'investissement et des objectifs de gestion définis.",
    PLACEMENT_IMMOBILIER: 'Société Civile de Placement Immobilier',
    PLACEMENT_COLLECTIF:
        "Organisme de placement collectif prenant la forme d'une société non cotée en bourse. La SCPI collecte de l'argent auprès de nombreux investisseurs dans l'unique objectif d'acquérir et gérer un patrimoine immobilier destiné à la location.",
    OPCVM: 'OPCVM (Organisme de Placement Collectif en Valeur Mobilière)',
    FIA: "FIA (Fonds d'investissement alternatif)",
    CAPITAUX_AUPRES:
        "Fonds d'investissement alternatif qui lèvent des capitaux auprès d'un certain nombre d'investisseurs en vue de les investir, dans l'intérêt de ces investisseurs, conformément à une politique d'investissement que ces FIA ou leurs sociétés de gestion définissent.",

    DISTRIBUTOR_PEDAGOGIC: "Bienvenue dans le parcours d'inscription des partenaires de Peqan",
    NECESSARY_DOCUMENTS: 'Documents à préparer pour votre inscription',
    DISTRIBUTOR_PEDAGOGIC_THANKS: "Merci de l'intérêt que vous portez à notre offre.",
    DISTRIBUTOR_PEDAGOGIC_PREPRARE: isPSI =>
        `Afin de bénéficier d'une expérience d'inscription digitale optimisée, nous vous invitons à préparer les${
            isPSI ? ' informations et' : ''
        } documents suivants :`,
    DISTRIBUTOR_PEDAGOGIC_OVERVIEW_COMMERCIAL:
        "Si vous disposez des documents ci-dessus, le processus d'inscription prendra moins d'une dizaine de minutes.",
    DISTRIBUTOR_PEDAGOGIC_OVERVIEW_APPORTEUR:
        "Le processus d'inscription prendra moins d'une dizaine de minutes et se terminera par la signature électronique de la convention d'apporteur d'affaire.",
    DISTRIBUTOR_PEDAGOGIC_MAIL_FOR_SIGNATURE:
        "Dès réception de votre inscription et après analyse des documents fournis, Peqan vous enverra un mail vous permettant d'accéder à votre espace partenaire.",
    DISTRIBUTOR_PEDAGOGIC_AFFIDAVIT: 'Pouvoir du signataire, le cas échéant',
    DISTRIBUTOR_PEDAGOGIC_LOGO_INFO_TITLE: 'Pourquoi votre logo\xa0?',
    DISTRIBUTOR_PEDAGOGIC_LOGO_INFO_CONTENT:
        "L'interface de communication de la plateforme à destination de vos clients pourra ainsi inclure le logo de votre société.",
    DISTRIBUTOR_PEDAGOGIC_QUESTION: 'Quel type de partenaire êtes-vous\xa0?',
    DISTRIBUTOR_PEDAGOGIC_CIF: "Conseil en Investissements Financiers enregistré auprès de l'ORIAS",
    DISTRIBUTOR_PEDAGOGIC_PSI:
        "Prestataire de Services d'Investissements agréé par l'ACPR pour fournir le service de conseil en investissements au sens de l'article L.321-1",
    ADMIN_CIF_EXPANDED: 'Conseil en Investissements Financiers',
    INVITE_DISTRIBUTOR_CERTIFIED:
        "En tant qu'administrateur, je certifie que l'utilisateur crée est dûment habilité  pour exercer l'activité de conseil en investissement financier",

    AUTRE_PERSONNE_MORRALE:
        "A noter que lorsqu'une personne morale est représentée par une autre personne morale ou une personne physique en capacité d'engager la responsabilité de la personne morale, la situation financière et les objectifs d'investissement sont ceux de la personne morale plutôt que ceux de son représentant.",

    KBIS_A_JOUR: 'Kbis de moins de 3 mois',
    STATUTS_A_JOUR: 'Derniers statuts certifiés conformes',
    DOCUMENTS_DE_IDENTITE:
        "Un document d'identité valide du représentant de la personne morale (Carte d'identité, Passeport, Permis de conduire biométrique)",
    RIB_DOC: 'RIB et IBAN du compte qui sera prélevé pour la souscription',
    LISTE_DES_BENEFICIAIRES: 'Registre des bénéficiaires effectifs (RBE)',
    DOCUMENTS_DE_IDENTITE_DES_BENEFICIAIRES:
        "Document d'identité des bénéficiaires effectifs (Carte d'identité, Passeport, Permis de conduire biométrique)",
    AUTO_CERTIFICATION_FATCA: 'Auto certification FATCA (si disponible)',

    PRO_CLIENT_BY_NATURE: 'Client professionnel par nature',
    CONSULT_JURIDIC_DOCUMENTATION: 'Consulter la documentation juridique et souscrire',
    PRO_CLIENT_INFO_TEXT_1:
        "Compte tenu de votre réponse, la société de gestion vous classifie comme client professionnel au sens de l'article L. 214-160 du code monétaire et financier.",
    PRO_CLIENT_INFO_TEXT_2:
        'De ce fait, vous pouvez consulter le règlement et le DIC Priips du fonds et souscrire.',

    LEGAL_ENTITY_IDENTIFICATION_NUMBER: "Numéro d'Identification d'Entité Juridique (LEI)",

    LISTE_DES_BENEFICIAIRES_EFFECTIFS:
        "Merci de bien vouloir charger la liste des bénéficiaires effectifs ou tout autre document permettant d'identifier les bénéficiaires",
    FATCA: "Si vous disposez d'une auto-certification FATCA, veuillez la charger ici",
    ASSOCIATE_IDENTIFY_WARNING:
        "Le souscripteur a chargé une organigramme ou un autre document permettant d'identifier les associés.",
    DIRECTOR_IDENTIFY_WARNING:
        "Le souscripteur a chargé une organigramme ou un autre document permettant d'identifier les directeurs.",
    ADMINISTRATOR_IDENTIFY_WARNING:
        "Le souscripteur a chargé une organigramme ou un autre document permettant d'identifier les administrateurs.",
    BENEFICIARY_IDENTIFY_WARNING:
        "Le souscripteur a chargé la liste des bénéficiaires effectifs ou tout autre document permettant d'identifier les bénéficiaires.",
    FATCA_DOC_WARNING: 'Le souscripteur a téléchargé une auto-certification FATCA.',

    BENEFICIARY_IDENTIFICATION_DOC: 'Identification des bénéficiaires',
    FATCA_DOC: 'Auto-certification FATCA',
    ADMINISTRATOR_IDENTIFICATION_DOC: 'Identification des administrateurs',
    DIRECTOR_IDENTIFICATION_DOC: 'Identification des directeurs',
    ASSOCIATE_IDENTIFICATION_DOC: 'Identification des associés',

    BENEFICIARY_NIF_WARNING: name => `Le NIF n'est pas disponible pour le bénéficiaire ${name}.`,
    FINANCIAL_INSTITUTION: 'Institution financière',

    CREATE_PASSWORD: 'Créez votre mot de passe',
    PRO_INVESTOR_BY_CHOICE: 'Professionnel sur option',
    PRO_INVESTOR_BY_NATURE: 'Professionnel par nature',
    EMAIL_SENT: "Un email a été envoyé à l'adresse saisie.",
    SUBSCRIPTION_ALREADY_IN_PROGRESS: 'Ce souscripteur a déjà une souscription en cours.',
    ACCOUNT_INELIGIBLE: 'Cette adresse correspond à un utilisateur ayant un autre rôle.',
    PRO_INCOME_SOURCES: 'Revenus professionnels',

    ELIGIBILITY_HAS_TOTAL_BALANCE_DOCS:
        'Disposez-vous de documents justificatifs* (ex: Dernier rapport annuel… )',
    ELIGIBILITY_HAS_EQUITY_DOCS:
        'Disposez-vous de documents justificatifs* (ex: Attestation de fonds propres… )',
    ELIGIBILITY_BALANCE_SHEET_TOTAL_DOC_WARNING:
        'Aucun document justificatif pour un total de bilan supérieur ou égal à 20 M€',
    ELIGIBILITY_NET_SALES_REVENUE_DOC_WARNING:
        "Aucun document justificatif pour un chiffre d'affaires ou recettes nettes supérieur ou égal à 40 M€",
    ELIGIBILITY_HIGHER_EQUITY_DOC_WARNING:
        'Aucun document justificatif pour des capitaux propres supérieurs ou égaux à 2 M€',
    ELIGIBILITY_BALANCE_SHEET_TOTAL_DOC_LABEL:
        'Document justificatif pour un total de bilan supérieur ou égal à 20 M€',
    ELIGIBILITY_NET_SALES_REVENUE_DOC_LABEL:
        "Document justificatif pour un chiffre d'affaires ou recettes nettes supérieur ou égal à 40 M€",
    ELIGIBILITY_HIGHER_EQUITY_DOC_LABEL:
        'Document justificatif pour des capitaux propres supérieurs ou égaux à 2 M€',
    TRANSACTIONS_COMPLETED_DOC_LABEL: 'Justificatif transactions',
    PORTFOLIO_VALUE_DOC_LABEL: 'Justificatif portefeuille',
    PROFESSIONAL_POSITION_HELD_DOC_LABEL: 'Justificatif expérience',
    ELIGIBILITY_TRANSACTION_DOCUMENTS:
        'Le souscripteur a déjà réalisé au moins 10 transactions (supérieures à 600 € chacune) par trimestre au cours des 4 derniers trimestres, mais aucun document fourni.',
    ELIGIBILITY_PORTOFOLIO_DOCUMENTS:
        "La valeur du portefeuille d'instruments financiers dépasse 500 000 €, mais aucun document fourni.",
    ELIGIBILITY_PRO_DOCUMENTS:
        'Le souscripteur occupe depuis au moins un an ou a occupé pendant au moins un an, dans le secteur financier, une position professionnelle requérant une connaissance des transactions ou des services envisagés, mais aucun document fourni.',
    ELIGIBILITY_ASSOCIATION_TYPE_WARNING:
        'Le souscripteur est un "Fonds de pension / Association / Organisme public"',
    ELIGIBILITY_NO_CRITERIA_SLP:
        'Je ne réponds à aucun des critères me permettant de souscrire à une SLP',
    ELIGIBILITY_INVESTOR_TYPE: 'Autre investisseur',

    USER_ADEQUACY_SUBTITLE_FCPR:
        "Pour déterminer si votre objectif d'investissement et votre profil sont adaptés à celui du fonds, nous devons nous assurer que vous avez connaissance des risques inhérents à ce type d'investissement et que ce placement correspond à vos attentes. De plus, nous devons nous assurer que vous disposez de la capacité financière à supporter le risque économique d'une souscription aux parts du fonds et continuez de disposer de moyens suffisants pour subvenir à vos besoins actuels et futurs et à de possibles imprévus.",
    SENSIBILITE_AUX_RISQUES: 'Sensibilité aux risques',
    SURVEY_RESULTS_FCPR_MESSAGE: fundName =>
        `Compte tenu de vos réponses, nous sommes heureux de vous informer que les caractéristiques du fonds ${fundName} sont en adéquation avec votre profil investisseur et que vous êtes éligible à la souscription dans ce fonds.`,
    KYC_NO_CARRIED_OUT_TRANSACTIONS_WARNING:
        'Nombre de transactions réalisées sur du non côtés au cours des 12 derniers mois : 0',
    RCS_REGISTRATION_ADDRESS_ONLY_LETTERS:
        "Le lieu d'immatriculation doit contenir uniquement des lettres",

    NO_RETROCESSION_UNIT_MARKETING: 'Commercialisation des parts sans commissions sur encours',

    AREA_OF_INTERVENTION: "Votre géographie d'intervention\xa0:",
    ALL_FRANCE: 'Toute la France',
    DEPARTMENTS: 'Départements\xa0:',
    COUNTY_PLACEHODER: 'Sélectionnez le(s) département(s)',
    ASSET_MANAGEMENT_AMOUNT: 'Quel est le montant de vos encours\xa0?',
    PRIVATE_EQUITY_ASSET_MANAGEMENT_AMOUNT:
        "Quelle part de l'actif sous gestion est investie en Private Equity\xa0?",
    DISTRIBUTION_WAYS:
        "Avez-vous déjà conseillé pour vos clients des solutions d'investissement de type Private Equity\xa0? Si oui, lesquelles\xa0?",
    CLIENT_REPARTITION: 'Quelle est la répartition de votre clientèle par typologie\xa0?',
    PRO_CLIENTS_PERCENTAGE: 'de clients professionnels',
    INFORMED_CLIENTS_PERCENTAGE: 'de clients avertis',
    NON_PRO_CLIENTS_PERCENTAGE: 'de clients non professionnels',
    TEXT_TOO_LONG: (maxLength = 250) => `Le texte ne doit pas dépasser ${maxLength} caractères.`,
    AVERAGE_PRIVATE_EQUITY_TICKET_AMOUNT:
        'Quel est en moyenne le montant du ticket investi par vos clients dans les instruments financiers de type Private Equity ? (en €)',
    REMUNERATION_METHOD: 'Quel type de parts souhaitez-vous commercialiser\xa0?',
    ACCEPT_REMUNERATION: 'Donnant droit à des rétrocessions de commissions sur encours',
    REJECT_REMUNERATION: 'Sans rétrocession de commissions sur encours',
    BOTH: 'Les deux',
    REMUNERATION_METHOD_ERROR: 'Vous devez choisir une option de rémunération',

    KYC_INVESTMENT_MGMT_WITH_ADVISOR:
        "Dans le cadre de ses investissements, le souscripteur a géré ses avoirs avec l'aide d'un conseiller.",
    KYC_INVESTMENT_MGMT_BY_DELEGATION:
        "Dans le cadre de ses investissements, le souscripteur a géré ses avoirs par délégation, dans le cadre d'un mandat de gestion.",
    COMPLEMENT: 'Complément',
    COMPLEMENTS: 'Compléments',
    GENERAL_INFO: 'Informations générales',
    ASSET_MANAGEMENT_AMOUNT_LABEL: 'Montant de vos encours',
    PRIVATE_EQUITY_ASSET_MANAGEMENT_AMOUNT_LABEL:
        "Part de l'actif sous gestion investi en Private Equity",
    CLIENT_REPARTITION_LABEL: 'Répartition de votre clientèle',
    DISTRIBUTION_WAYS_LABEL: "Conseils des solutions d'investissement de type Private Equity",
    AVERAGE_PRIVATE_EQUITY_TICKET_AMOUNT_LABEL:
        'Montant du ticket dans les instruments financiers de type Private Equity',
    REMUNERATION_METHOD_LABEL: 'Mode de rémunération',
    PAYMENT_CHOICE: 'Mode de règlement',
    PAYMENT_CHOICE_UNIQUE: 'Unique',
    PAYMENT_CHOICE_FUND_RAISING: 'Par appels de fonds',

    CHOOSE_SHARE_CATEGORY: 'Choisissez la catégorie de parts',
    REMUNERATION_BY_RETROCESSION: 'parts rémunérées par rétrocession',
    REMUNERATION_BY_RETROCESSION_INDIRECT: 'Je souhaite percevoir des rétrocessions sur encours',
    REMUNERATION_BY_HONORARY: 'parts rémunérées par honoraires',
    REMUNERATION_BY_HONORARY_INDIRECT: 'Je ne souhaite pas percevoir des rétrocessions',
    SHARE: 'parts',
    START_SUBSCRIPTION: 'Démarrage de la souscription',
    START_YOUR_CLIENT_SUBSCRIPTION:
        'Vous allez maintenant pouvoir démarrer le parcours de souscription de votre client.',

    FINISH_INDIRECT_SUBSCRIPTION_TITLE: 'Souscription finalisée',
    FINISH_INDIRECT_SUBSCRIPTION_CONTENT_1:
        'Vous pouvez transférer la souscription à votre client maintenant en cliquant sur le bouton ci-dessous, ou plus tard à partir du menu SOUSCRIPTIONS EN COURS.',
    FINISH_INDIRECT_SUBSCRIPTION_CONTENT_2:
        'Pour revenir à votre espace distributeur, quittez la Vue souscripteur.',

    REMUNERATIONS: 'Commissions de distribution',
    TOTAL_SUBSCRIPTIONS_FLUX: 'Flux total de souscriptions',
    ADMISSION_FEE_COMMISSIONS: 'Commissions sur apport',
    MANAGEMENT_FEE_COMMISSIONS: 'Commissions sur encours',
    REPORTING: 'Reporting',
    REPORT_AT: 'Rapport de gestion au',
    MANAGEMENT_REPORTS: 'Rapports de gestion',
    CAPITAL_ACCOUNTS: 'Relevés de situation',
    CAPITAL_ACCOUNT: 'Relevé de situation',
    STANDARD: 'Standard',
    INSCRIPTION_DOCS: "Documents d'inscription",
    CONVENTIONS: 'Conventions',
    INVOICES: 'Relevés de facturation',
    DISTIBUTOR_INVOICE: 'Relevé de facturation',
    DISTIBUTOR_INVOICE_EXCEL: 'Relevé de facturation Excel',
    DISTRIBUTOR_DOCUMENTS: "Documents d'inscription",

    VISIBILITY: 'Visibilité',
    PRIVACY: 'Produit réservé',
    OPEN: 'Ouvert',
    DEFINITION: 'Définition',
    PRO_CLIENTS_INFO: 'Un client professionnel est soit\xa0:',
    PRO_CLIENTS_INFO_OPTION_1:
        'Une entité agréée ou réglementée pour opérer sur les marchés financiers\xa0;',
    PRO_CLIENTS_INFO_OPTION_2:
        'Une entreprise française ou étrangère remplissant au moins 2 des 3 critères suivants\xa0:',
    PRO_CLIENTS_INFO_OPTION_2_1: "Total du bilan égal ou supérieur à 20 millions d'euros\xa0;",
    PRO_CLIENTS_INFO_OPTION_2_2:
        "Chiffre d'affaires net égal ou supérieur à 40 millions d'euros\xa0;",
    PRO_CLIENTS_INFO_OPTION_2_3: "Capitaux propres égaux ou supérieurs à 2 millions d'euros.",
    PRO_CLIENTS_INFO_OPTION_3: 'Un client professionnel sur option\xa0:',
    PRO_CLIENTS_INFO_OPTION_3_BECOME_PRO:
        "Un client non professionnel ayant notifié son souhait d'être considéré comme un client professionnel à la condition qu'il respecte deux des trois critères suivants\xa0:",
    PRO_CLIENTS_INFO_OPTION_3_1:
        "La détention d'un portefeuille d'instruments financiers d'une valeur supérieure à 500 000 euros\xa0;",
    PRO_CLIENTS_INFO_OPTION_3_2:
        "La réalisation d'opérations, chacune d'une taille significative, sur des instruments financiers, à raison d'au moins dix par trimestre en moyenne sur les quatre trimestres précédents\xa0;",
    PRO_CLIENTS_INFO_OPTION_3_3:
        "L'occupation pendant au moins un an, dans le secteur financier, d'une position professionnelle exigeant une connaissance de l'investissement en instruments financiers.",
    INFORMED_CLIENTS_INFO_1:
        "Un client averti est un client non professionnel qui justifie de l'expérience, des compétences et des connaissances pour investir dans un instrument financier.",
    INFORMED_CLIENTS_INFO_2:
        'Cette notion de client averti est utilisée notamment dans le cadre de la souscription de FPCI (Fonds Professionnel de Capital Investissement) qui peuvent être ouverts à la souscription pour les investisseurs avertis.',
    INFORMED_CLIENTS_INFO_2_FPS:
        'Cette notion de client averti est utilisée notamment dans le cadre de la souscription de FPS (Fonds Professionnel Spécialisé) qui peuvent être ouverts à la souscription pour les investisseurs avertis.',
    NON_PRO_CLIENTS_INFO:
        'Un client non professionnel est un client qui ne peut pas être catégorisé comme client professionnel ou averti.',

    DISTRIBUTOR_COMPANY_NAME: 'Nom distributeur',
    SEARCH: 'Rechercher',
    CHOOSE: 'Choisir',
    SELECT_ALL: 'Sélectionner tout',
    DISTRIBUTOR_SEARCH_WARNING: 'Vous devez saisir le nom du cabinet.',
    DISTRIBUTOR_NOTIFIED_1: sgpName =>
        `Votre conseiller financier est déjà partenaire de ${sgpName} pour ce produit .`,
    DISTRIBUTOR_NOTIFIED_2:
        'Il sera informé de votre intérêt et vous enverra un lien pour réaliser votre souscription.',
    DISTRIBUTOR_NOTIFIED_3:
        'Afin de valider votre choix, veuillez cliquer sur le bouton Suivant en bas de page.',
    SEARCH_NO_RESULTS: "Aucun résultat n'a été trouvé selon vos données.",
    CONTACT_DISTRIBUTOR:
        'Un conseiller en investissements financiers va prochaînement vous contacter.',
    EMPTY_TABLE_DEFAULT: "Il n'y a pas d'enregistrements.",
    NO_RESULTS_FOUND: 'Aucun résultat trouvé.',
    RESULTS_FOR_KEYWORD: keyword => `Résultats de la recherche pour "${keyword}" :`,
    NO_DISTRIBUTORS_FOUND:
        "Votre Conseiller en Investissement Financier n'est, à ce jour, pas dans notre liste de Partenaires. Nous allons immédiatement prendre contact avec votre Conseiller pour vous permettre de poursuivre votre parcours de souscription. Nous reviendrons vers vous dans les plus brefs délais.",

    EXPERIENCE_INCONSISTENCY:
        'Questionnaire Expérience: Réponse incohérente sur le nombre de transactions réalisées entre la question 1 et la question 4\xa0:',
    EXPERIENCE_INCONSISTENCY_OPT_1: nbTransactions =>
        `Le souscripteur indique ${nbTransactions} transaction(s) réalisée(s) au cours des 12 derniers mois sur le non coté`,
    EXPERIENCE_INCONSISTENCY_OPT_2: 'Le souscripteur indique',
    EXPERIENCE_INCONSISTENCY_OPT_2_1: nonCoteChoice => `${nonCoteChoice} sur les actions non cotés`,
    EXPERIENCE_INCONSISTENCY_OPT_2_2: partsChoice =>
        `${partsChoice} sur les parts de Parts de FCPR/FPS/FPCI etc.`,

    KYC_INSTRUMENTS_INEXPERIENCED:
        "Le souscripteur ne dispose pas d'expérience du non cotés et pas d'expérience sur les marchés financiers. Son profil est inexpérimenté et doit être étudié avec vigilance.",
    KYC_INVESTMENTS_INEXPERIENCED: investments =>
        `Le souscripteur ne dispose d'une expérience récente dans la souscription d'instrument financier. Au cours des 12 derniers mois, il a investi dans : ${investments}`,
    KYC_NO_INVESTMENTS: 'Aucun investissement réalisé au cours des 12 derniers mois.',
    NOT_TRANSFERED: 'Non transmise',
    NOT_ACTIVATED: 'Non activée',
    NO_UNLISTED_SHARES:
        "Au cours des 12 derniers mois, le souscripteur n'a pas investi dans des actions non cotées.",
    NO_PRIVATE_EQUITY_INVESTMENTS:
        "Au cours des 12 derniers mois, le souscripteur n'a pas investi dans des Parts de FCPR/FPS/FPCI etc.",

    SENT_MESSAGES: 'Messages reçus',
    USER_TYPE: 'Type utilisateur',
    SENDING_DATE: "Date de l'envoi",
    MESSAGE_SUBJECT: 'Objet du message',
    MESSAGE_CONTENT: 'Contenu du message',

    FINANCIAL_FLOW: 'Flux financiers',
    DIRECT_DEBIT_TO_FUNDS: 'Prélèvements vers fonds',
    TRANSFER_TO_FUNDS: 'Virements vers fonds',
    PENDING_TRANSFERS: 'Virements en attente',
    TRANSFER_HISTORY: 'Historique des virements',
    IN_PROCESS_DEBITS: 'Prélèvements à exécuter',
    PENDING_DEBITS: 'Prélèvements en attente',
    DEBITS_HISTORY: 'Historique des prélèvements',
    FIRST_DEBIT_DATE: 'Date prévisionelle de prélèvement',
    FIRST_TRANSFER_DATE: 'Date prévisionelle du virement',
    TRANSFER_DATE: 'Date du virement',
    ORDER_NUMBER: 'Numéro',
    SETTLED_BY: 'Réception faite par',
    SETTLE_PAYMENT: 'Solder',
    CREDIT_PAYMENT: 'Créditer',
    CREDIT_AMOUNT_LABEL: 'Saisir le montant crédité',
    CREDITED_AMOUNT: 'Montant crédité',
    SUM_REMAINING: 'Montant restant dû',
    AMOUNT_INVALID: "Le montant saisi n'est pas valide",
    CREDIT_AMOUNT_MAX: 'Le montant saisi dépasse la somme restante à payer',
    RESET_PAYMENT: 'Repositionner le prélèvement',
    MOVE_PAYMENT: 'Déplacer vers prélèvements en attente',
    FIRST_INSTALLMENT: 'Tranche initiale',
    FUND_CALL: no => `Appel\xa0${no}`,
    CLOSING_NUMBER: no => `Closing\xa0${no}`,
    FULL_CALL: 'Appel intégral',
    FUTURE_PAYMENTS_TOTAL: 'Total prélèvements à venir',
    EXECUTABLE_PAYMENTS_TOTAL: 'Total prélèvements exécutables',
    EXECUTE_PAYMENTS: 'Exécuter les prélèvements',
    PAYMENTS_EXECUTION: 'Execution des prélèvements',
    PAYMENTS_TOTAL: 'Total prélèvements',
    PAYMENT_EXECUTION_DATE: "Date d'exécution du prélèvement",

    SUBSTITUTION_MODE: 'Mode substitution',
    SEPA_ALREADY_GENERATED_TODAY: "Vous avez déjà généré le fichier SEPA aujourd'hui.",
    FUND_CALLS_REASON: 'Commentaire sur appel de fonds',
    FUND_CALLS_PREMIUM: 'Taux pour prime',
    FUND_CALL_NOTICE: "Notice d'appel de fonds",
    ENTER_SUBSCRIPTION_PREMIUM: 'Entrer le taux pour la prime de souscription',
    DOWNLOAD_GENERATED_DOCUMENTS: 'Télécharger les documents générés',
    SEND_GENERATED_DOCUMENTS: 'Envoyer les notices au dépositaire',
    SEND_GENERATED_DOCUMENTS_CONTENT:
        'Etes-vous sûrs de vouloir envoyer les notices au dépositaire\xa0?',
    SEND_GENERATED_DOCUMENTS_SUCCESS: "L'envoi des notices a été lancé",
    NUMBER_FIELD_ERROR: 'Le champ doit être un numéro',
    SUBSCRIPTION_PREMIUM: 'Prime de souscription',

    DISTRIBUTOR_FIRSTNAME: 'Prénom du conseiller',
    DISTRIBUTOR_LASTNAME: 'Nom du conseiller',
    CLOSE: 'Fermer',
    TUNNEL_CHANGES_ALERT_TITLE: 'Évolution du parcours de souscription',
    TUNNEL_CHANGES_ALERT_CONTENT: [
        'Pour renforcer la conformité de notre plateforme à la réglementation, nous avons effectué quelques modifications dans le parcours de souscription.',
        'Le questionnaire de caractère approprié devra être renseigné entièrement par le souscripteur après transmission, et ne pourra plus être prérempli par un conseiller.',
        "Il vous appartient de vérifier que votre client possède les compétences, les connaissances et l'expérience nécessaires à la souscription dans le fonds de capital investissement que vous lui proposez.",
        'Dans le cadre de votre conseil en investissement prodigué à votre client, celui-ci doit en particulier être en mesure de répondre aux questions suivantes :',
        '- Le fonds présente-t-il un risque de perte en capital ?',
        '- Le fonds est-il liquide ?',
        '- Le souscripteur est-il tenu de répondre aux appels à hauteur de son engagement ?',
        '- Le fonds est-il un fonds à long terme ?',
    ],
    SENT_SUBSCRIPTIONS: 'Souscriptions envoyées',
    SENT_DATE: "Date de l'envoi",
    SHARE_CATEGORY: 'Catégorie de parts',
    CATEGORY_NAME: 'Nom de la catégorie',
    PRIVATE: 'Privée',
    SHARE_SUBCATEGORY_EXIST: m =>
        m === 'sub_share_category_unique_name' ? 'Le nom de la sous-catégorie existe déjà' : m,
    SHARE_CATEGORY_EXIST: m =>
        m === 'Cette valeur est déjà utilisée.' ? 'Le nom de la catégorie existe déjà' : m,
    CHOOSE_PAYMENT_MODE: 'Vous devez cocher au moins un mode de règlement.',
    CREATOR: 'Emetteur',
    ENGAGED: 'Engagée',
    EMAIL: 'Email',
    EMAIL_SUBSCRIBER: 'Email souscripteur',
    EMAIL_INFO_1: "L'email est l'identifiant du souscripteur.",
    EMAIL_INFO_2: 'Aucun email ne lui est envoyé à ce stade.',
    SIGNATURE_IMAGE: 'Signature à placer sur les documents',
    DOCUMENTS_FOOTER_TEXT: 'Texte de pied de page',
    NEW_SUBSCRIPTION_TITLE: 'Confirmation des données',
    INDIRECT_UBSCRIPTION_DISCLAIMER:
        'Si vous souhaitez investir dans un autre de nos produits, nous vous invitons à contacter votre distributeur.',

    ACTIONS_TO_TAKE: 'ACTIONS À RÉALISER',
    ONGOING: 'EN COURS',
    COMPLETED: 'RÉALISÉ',
    ONGOING_2: 'En cours',
    COMPLETED_2: 'Réalisées',
    SUBSCRIPTIONS_STATE:
        "Etat d'avancement des souscriptions en cours transférées à l'investisseur non-activées",
    INTERRUPTED_INSCRIPTIONS: 'Inscriptions interrompues',
    UNFINISHED_INSCRIPTIONS: 'Inscriptions non finalisées',
    INTERRUPTED_SUBSCRIPTIONS: 'Souscriptions interrompues',
    INDIRECT_SUBSCRIPTIONS_PENDING_TRANSFER: 'Souscriptions via partenaires non transmises',
    DURATION: 'Durée (depuis la date de transfert)',
    PERIOD: 'Période',
    SUBSCRIPTION_NUMBER: 'Nombre de souscriptions',
    INSCRIPTIONS_NUMBER: "Nombre d'inscriptions",
    DAYS: 'jours',
    CONVENTIONS_TO_BE_GENERATED: 'Conventions à générer',
    CONVENTIONS_TO_BE_SIGNED: 'Conventions à signer',
    DISTRIBUTOR_WITHOUT_COMMERCIAL: 'Distributeurs sans commercial',
    SUBSCRIPTIONS_TO_BE_VERIFIED: 'Souscriptions en attente de vérification par le distributeur',
    SUBSCRIPTIONS_TO_BE_VALIDATED: 'Souscriptions à valider',
    SUBSCRIPTIONS_TO_BE_SIGNED: 'Souscriptions à signer',
    SUBSCRIPTIONS_PENDING_ACTIVATION: "Souscriptions transférées non activées par l'investisseur",
    SUBSCRIPTIONS_PENDING_TRANSFER: 'Souscriptions à transférer',
    CRITICAL_WARNING_ONGOING_SUBSCRIPTIONS: 'Souscriptions en cours avec alertes rouges',
    RIB_CHANGES_TO_VALIDATE: 'Changement du RIB à valider',
    SUBSCRIPTIONS_BY_PRODUCT: 'Souscriptions par produit',
    SUBSCRIPTIONS_BY_COMMERCIAL: 'Souscriptions par Conseiller',
    NUMBER: 'Nombre',
    VALUE: 'Valeur',
    VALORISATION: 'Valorisation',
    DISTRIBUTIONS: 'Distributions',
    DPI: 'D/PI',
    RVPI: 'RV/PI',
    TVPI: 'TV/PI',
    ALL_1: 'Tous',
    ALL_2: 'Toutes',
    TRANSFERED: 'Transférées',
    NON_TRANSFERED: 'Non transférées',
    SUBSCRIPTIONS_VALUE_BY_PRODUCT: 'Valeurs des souscriptions par produit',
    SUBSCRIPTIONS_VALUE_BY_SHARE: 'Valeur des souscriptions par part',
    TRANSFERED_SUBSCRIPTIONS_VALUE_BY_PRODUCT: 'Valeur des souscriptions transférées par produit',
    TRANSFERED_SUBSCRIPTIONS_VALUE_BY_SHARE: 'Valeur des souscriptions transférées par part',
    NON_TRANSFERED_SUBSCRIPTIONS_VALUE_BY_PRODUCT:
        'Valeur des souscriptions non transférées par produit',
    NON_TRANSFERED_SUBSCRIPTIONS_VALUE_BY_SHARE:
        'Valeur des souscriptions non transférées par part',
    SUBSCRIPTIONS_NUMBER_BY_PRODUCT: 'Nombre des souscriptions par produit',
    SUBSCRIPTIONS_NUMBER_BY_SHARE: 'Nombre des souscriptions par part',
    TRANSFERED_SUBSCRIPTIONS_NUMBER_BY_PRODUCT: 'Nombre des souscriptions transférées par produit',
    TRANSFERED_SUBSCRIPTIONS_NUMBER_BY_SHARE: 'Nombre des souscriptions transférées par part',
    NON_TRANSFERED_SUBSCRIPTIONS_NUMBER_BY_PRODUCT:
        'Nombre des souscriptions non transférées par produit',
    NON_TRANSFERED_SUBSCRIPTIONS_NUMBER_BY_SHARE:
        'Nombre des souscriptions non transférées par part',
    NO_DISTIBUTOR_SUBSCRIPTIONS: "Ce conseiller n'a aucune souscription.",
    NO_DISTIBUTOR_TRANSFERED_SUBSCRIPTIONS: "Ce conseiller n'a aucune souscription transférée.",
    NO_DISTIBUTOR_NON_TRANSFERED_SUBSCRIPTIONS:
        "Ce conseiller n'a aucune souscription non transférée.",
    NO_SUBSCRIPTIONS_FOR_PODUCT: 'Aucune souscription pour ce fonds.',
    NO_TRANSFERED_SUBSCRIPTIONS_FOR_PRODUCT: 'Aucune souscription transférée pour ce fonds.',
    NO_NON_TRANSFERED_SUBSCRIPTIONS_FOR_PRODUCT:
        'Aucune souscription non transférée pour ce fonds.',
    DIRECT_SUBSCRIPTIONS_VALUE_BY_SHARE: 'Valeurs des souscriptions directes par part',
    DIRECT_SUBSCRIPTIONS_VALUE_BY_PRODUCT: 'Valeurs des souscriptions directes par produit',
    DIRECT_SUBSCRIPTIONS_NUMBER_BY_SHARE: 'Nombre des souscriptions directes par part',
    DIRECT_SUBSCRIPTIONS_NUMBER_BY_PRODUCT: 'Nombre des souscriptions directes par produit',
    INDIRECT_SUBSCRIPTIONS_VALUE_BY_SHARE: 'Valeurs des souscriptions indirectes par part',
    INDIRECT_SUBSCRIPTIONS_VALUE_BY_PRODUCT: 'Valeurs des souscriptions indirectes par produit',
    INDIRECT_SUBSCRIPTIONS_NUMBER_BY_SHARE: 'Nombre des souscriptions indirectes par part',
    INDIRECT_SUBSCRIPTIONS_NUMBER_BY_PRODUCT: 'Nombre des souscriptions indirectes par produit',
    TOTAL_PARTNERS: 'Partenaires inscrits',
    TOTAL: 'Total',
    NO_CONVENTIONS_PARTNERS: 'Partenaires inscrits',
    AT_LEAST_ONE_CONVENTION_PARTNERS: 'Partenaires ayant signé une convention',
    AT_LEAST_ONE_SUBSCRIPTION_PARTNERS: 'Partenaires ayant réalisé au moins une souscription',
    SIGNED_CONVENTIONS: 'Conventions signées',
    CONSULTANT_ACTIVITY: 'ACTIVITÉ DE VOS CONSEILLERS',
    YOUR_ACTIVITY: 'VOTRE ACTIVITÉ',
    COMMERCIALISED_PRODUCTS: 'Produits disponibles à la souscription',
    SUBSCRIPTIONS_TO_VALIDATE: 'Souscriptions à vérifier',
    OTHER_AVAILABLE_PRODUCTS: 'Autres produits disponibles',
    COMMERCIALISATION: 'COMMERCIALISATION',
    SUBSCRIPTIONS_TO_CONTINUE: 'Souscriptions à continuer',
    CLIENT_SUBSCRIPTIONS_TO_FINALIZE: 'Souscriptions à finaliser par vos clients',
    NO_CONVENTIONS: 'Veuillez signer une convention parmi les produits disponibles de votre choix',
    NO_AVAILABLE_PRODUCTS: 'Les conventions sont signées pour tous les produits disponibles',

    EXIGIBILITY_DATE: 'Date exigibilité',
    START_DATE: 'Date début',
    END_DATE: 'Date fin',

    DISCONNECT_REMINDER:
        'Si vous ne disposez pas actuellement des documents ou informations demandés, vous pourrez continuer plus tard votre souscription à la même étape en vous reconnectant. Pour sortir du parcours de souscription, merci de cliquer sur le bouton Quitter (en haut à droite).',

    VL_MANAGEMENT: 'Gestion de la VL',
    FUND_ATTRIBUTES: 'Attributs du fonds',
    PRIVATE_FUNDS_FOR_DISTRIBUTORS: 'Produit réservé au(x) distributeur(s)',
    CHOOSE_DISTIBUTORS_WITH_ACCESS:
        'Choisir le(s) distributeur(s) qui peuvent commercialiser ce produit',
    NEED_AT_LEAST_ONE_DISTIBUTOR: 'Vous devez sélectionner au moins un distributeur',
    VL_HISTORY: 'Historique de la VL',
    ADD_ENTRY: 'Ajouter un nouveau enregistrement',
    SEND_CAPITAL_ACCOUNT: 'Envoi du capital account',
    CAPITAL_ACCOUNT_ACTIVATION: 'Activation du capital account',
    CONFIRM_CAPITAL_ACCOUNT_ACTIVATION: 'Etes-vous sûrs de vouloir activer le capital account\xa0?',
    ANNUAL_TRI: 'TRI Annuel',
    IRR: 'TRI',
    FILL_ALL_DATA: 'Vous devez saisir toutes les données pour pouvoir sauvegarder',
    DECIMALS_ERROR: 'Vous devez saisir 2 décimales',
    SUBSCRIBERS: 'Souscripteurs',
    DISTRIBUTORS: 'Distributeurs',
    RECIPIENTS: 'Destinataires',
    REPORTING_DATE: 'Date reporting',
    DOCUMENT: 'Document',
    REPORTING_HISTORY: 'Historique du reporting',
    REPORTING_ACTIVATION: 'Activation du reporting',
    CONFIRM_REPORTING_ACTIVATION: 'Etes-vous sûrs de vouloir activer le reporting\xa0?',

    NETWORK_AMIN_ACCOUNT_ACTIVATED: "Vous avez activé votre espace en tant qu'Animateur de réseau.",
    NETWORK_AMIN_ACCOUNT_INFO_1:
        "Votre espace sera créé au sein de notre plateforme digitale une fois les vérifications d'usage effectuées par notre société de gestion.",
    NETWORK_AMIN_ACCOUNT_INFO_2:
        'Nous vous enverrons un email de confirmation une fois votre espace activé.',
    PLATFORM_TEAM_AVAILABLE_BY_EMAIL: "L'équipe Peqan est à votre disposition par email",
    CORDIALEMENT: 'Cordialement',

    NETWORKS: 'Réseaux',
    NETWORK_NAME: 'Nom réseau',
    ANIMATORS: 'Animateurs',
    CREATE_NETWORK: 'Créer un réseau',
    EDIT_NETWORK: 'Modifier le réseau',
    EMPTY_NETWORK_NAME: 'Vous devez saisir le nom du réseau.',
    EMPTY_PARTNER_LIST: 'Vous devez sélectionner un partenaire.',
    EMPTY_PRODUCT_LIST: 'Vous devez sélectionner un produit.',
    EMPTY_ADMIN_LIST: 'Vous devez sélectionner un animateur.',
    NETWORK_NAME_EXISTS: 'Le nom du réseau existe déjà dans notre base de données.',
    NETWORK_PRODUCT_MISMATCH:
        "La relation entre le(s) produit(s) et les distributeu(s) sélectionnés n'est pas possible.",

    COMMUNICATIONS: 'Communications',
    COMPANY_EMAILS: 'Adresses pour les relevés de facturation',
    REPORTING_EMAILS: 'Adresses pour les reportings',
    REPORTING_INVESTOR_EMAILS: 'Adresses additionnelles pour les reportings',
    FUND_CALL_AND_DISTRIBUTION_EMAILS: 'Adresses pour les appels de fonds et les distributions',
    FUND_CALL_AND_DISTRIBUTION_INVESTOR_EMAILS:
        'Adresses additionnelles pour les appels de fonds et les distributions',
    CAPITAL_ACCOUNTS_EMAILS: 'Adresses pour les relevés de situation',
    CAPITAL_ACCOUNTS_INVESTOR_EMAILS: 'Adresses additionnelles pour les relevés de situation',
    SUBSCRIPTION_PROGRESS_EMAILS: 'Adresses pour les parcours de souscription',
    SUBSCRIPTION_PROGRESS_INVESTOR_EMAILS:
        'Adresses additionnelles pour les parcours de souscription',
    EMAIL_DUPLICATE: 'Cette adresse est déjà saisie.',

    POSTAL_ADDRESS: 'Adresse postale',
    SIGNER_FIRST_NAME: 'Prénom du signataire',
    BS_SIGNATURE_DATE: 'Date de contre-signature du BS',
    COMPLEMENTARY_ADDRESSES: 'Adresse complémentaires',

    // ---- SGP companies ----
    SGP_PROVIDERS: 'AIFM',
    SGP_PROVIDER: 'AIFM',
    SGP_CREATE_PROVIDER: 'Créer un AIFM',
    SGP_EDIT_PROVIDER: 'Modifier un AIFM',
    SGP_PROVIDER_NAME: "Nom de l'AIFM",
    SGP_PROVIDER_LOGO: "Logo de l'AIFM",
    SGP_NAME_INVALID: 'Un AIFM avec ce nom existe déjà',
    SGP_DISTRIBUTOR_BILLING_EMAIL: 'Adresse relevés de facturation',
    BANK_PROVIDER_IDENTIFIER: 'Identifiant du créancier',

    // ---- Promoters ----
    PROMOTER: 'Promoteur',
    PROMOTERS: 'Promoteurs',
    PROMOTER_CREATE: 'Créer un promoteur',
    PROMOTER_EDIT: 'Modifier un promoteur',
    PROMOTER_NAME: 'Nom du promoteur',
    PROMOTER_LOGO: 'Logo du promoteur',
    PROMOTER_CREATE_USER: 'Créer un utilisateur promoteur',
    PROMOTER_USERS: 'Utilisateurs promoteurs',
    PROMOTER_NAME_EXISTS: 'Un promoteur avec ce nom existe déjà',
    PROMOTER_NAME_INVALID: 'Le nom ne doit contenir que des caractères alphanumériques',
};
